/*!
 * Txplayer - v3.0.0 - 2022-10-26 10:46:17
 * Copyright (c) 2022
 * Powered by Tencent-Video Web Front End Team
 */
! function (r) {
    var o = {};

    function i(e) {
        if (o[e]) return o[e].exports;
        var t = o[e] = {
            i: e,
            l: !1,
            exports: {}
        };
        return r[e].call(t.exports, t, t.exports, i), t.l = !0, t.exports
    }
    i.m = r, i.c = o, i.d = function (e, t, r) {
        i.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        })
    }, i.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, i.t = function (t, e) {
        if (1 & e && (t = i(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (i.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var o in t) i.d(r, o, function (e) {
                return t[e]
            }.bind(null, o));
        return r
    }, i.n = function (e) {
        var t = e && e.__esModule ? function () {
            return e.default
        } : function () {
            return e
        };
        return i.d(t, "a", t), t
    }, i.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, i.p = "", i(i.s = 4)
}([function (e, t, r) {
    var o;

    function i(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function s(e) {
        return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e
        } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }
    var f = (i(o = {
            isUseHls: function (e) {
                return "chromehls" === e.config.playerType
            },
            loadSubPlugins: function (e) {
                var t, r, o, i, n = e.context,
                    a = null === (t = n.pluginConfig) || void 0 === t || null === (r = t.subPlugins) || void 0 === r || null === (o = r.slice) || void 0 === o ? void 0 : o.call(r, 0);
                null != a && a.length && (i = {
                    config: n.config,
                    msg: n.msg,
                    userMsg: n.userMsg,
                    dataset: n.dataset,
                    $mod: {
                        $videomod: e.dataset.$videomod
                    }
                }, f.loadPlugins.call(e, a, i))
            },
            eventSuffix: ".txplayer",
            getNSEventName: function (e, t) {
                return e + (f.eventSuffix + t.config.playerId)
            },
            isTouchPlayer: function (e) {
                return "touch" === e.config.playerType
            },
            bindPopupClick: function (t) {
                var r = "txp_touch_hide";
                t.on("click", function (e) {
                    -1 === e.target.className.indexOf("txp_touch_popup_title") && (t.addClass(r), setTimeout(function () {
                        t.removeClass(r), t.hide()
                    }, 300))
                })
            },
            getHlsAdOffsetTime: function (e, t, r) {
                var o = t.dataset.hlsAdTimeRanges;
                if (!t.dataset.useHls || !o || !o.length) return e;
                var i = this.isTimeInHlsAdRange(e, t);
                if (!r && i) return i;
                for (var n = 0, a = o.length; n < a; n++) {
                    var s = o[n],
                        l = s.start,
                        c = s.end;
                    if (!(l < e)) break;
                    r ? e += c - l : e -= c - l
                }
                return e
            },
            parseGetinfoHlsAdRange: function (e) {
                var t = [];
                if (!e || !e.adpinfo) return t;
                var r = null;
                try {
                    r = JSON.parse(e.adpinfo)
                } catch (e) {
                    f.v4log("parseHlsAdRange: adpinfo parse err")
                }
                return !r || !r.plugin_info || r.plugin_info.length <= 0 || r.plugin_info.forEach(function (e) {
                    2 == +e.optype && t.push({
                        start_time: e.ad_time,
                        duration: e.ad_dura
                    })
                }), t
            },
            isTimeInHlsAdRange: function (e, t, r) {
                var o = t.dataset.hlsAdTimeRanges;
                if (!t.dataset.useHls || !o || !o.length) return !1;
                for (var i = 0; i < o.length; i++) {
                    var n = o[i];
                    if (n.start <= e && e <= n.end) return !!r || n.start
                }
                return !1
            },
            error: function (t) {
                if (window.console && window.console.error) {
                    var e = new Date;
                    t = "[" + e.getHours() + ":" + e.getMinutes() + ":" + e.getSeconds() + "]" + t;
                    try {
                        throw t
                    } catch (e) {
                        window.console.error(t)
                    }
                }
            },
            v4log: function (e, t) {
                if (window.console && window.console.log && Txplayer && Txplayer.dataset && Txplayer.dataset.debug) {
                    var r = "";
                    try {
                        r = JSON.stringify(t)
                    } catch (e) {}
                    Txplayer && Txplayer.util && Txplayer.util.localLog(e, r);
                    var o = this.dateFormat("hh:mm:ss:S");
                    window.console.log.apply(window.console, ["[v4Txplayer]", "[" + o + "]"].concat(Array.prototype.slice.call(arguments)))
                }
            },
            log: function () {
                if (window.console && window.console.log) try {
                    Txplayer && Txplayer.dataset && Txplayer.dataset.debug && window.console.log.apply && window.console.log.apply(window.console, arguments)
                } catch (e) {}
            },
            showInfo: function (e, t) {
                if (window.console && window.console.log) {
                    var r = 0;
                    if ("object" === s(t) && window.JSON && window.JSON.stringify) {
                        try {
                            t = JSON.stringify(t)
                        } catch (e) {
                            r = 1
                        }
                        if (r) return
                    }
                    var o = this.dateFormat("yyyy-MM-dd hh:mm:ss:S");
                    Txplayer.dataset.logData.push({
                        time: o,
                        info: e,
                        data: t
                    }), f.log("%c[Txplayer]%c[" + o + "]%c" + e + ": %c \t\t" + t, "color: #aaa", "background: #fff; color:#999;", "background: #000;color:#fff;", "color:green;");
                    var i;
                    Txplayer.dataset.logData && 500 < (i = Txplayer.dataset.logData.length) && (Txplayer.dataset.logData = Txplayer.dataset.logData.slice(i - 500, i))
                }
            },
            showError: function (e, t) {
                window.console && window.console.log && f.log("%c" + e + ": %c " + t, "background: #ccc;color:#fff;", "color: red;")
            },
            fiddlerLog: function (e) {
                Txplayer && Txplayer.dataset && !Txplayer.dataset.debug || ("string" != typeof e && "number" != typeof e || (e = {
                    a: e
                }), (new Image).src = "http://test.m.v.qq.com/txplayer?" + Txplayer.$.param(e))
            },
            cookie: {
                set: function (e, t, r, o, i) {
                    var n, a;
                    return i && (n = new Date, (a = new Date).setTime(n.getTime() + 36e5 * i)), document.cookie = e + "=" + t + "; " + (i ? "expires=" + a.toGMTString() + "; " : "") + (o ? "path=" + o + "; " : "path=/; ") + (r ? "domain=" + r + ";" : "domain=" + window.location.host + ";"), !0
                },
                get: function (e) {
                    var t = new RegExp("(?:^|;+|\\s+)" + e + "=([^;]*)"),
                        r = document.cookie.match(t);
                    return r ? r[1] : ""
                },
                del: function (e, t, r) {
                    var o = new Date;
                    o.setTime(o.getTime() - 1), document.cookie = e + "=; expires=" + o.toGMTString() + ";" + (r ? "path=" + r + "; " : "path=/; ") + (t ? "domain=" + t + ";" : "domain=" + window.location.host + ";")
                }
            },
            object2string: function (e, t) {
                t = void 0 !== t ? t : "&";
                var r = [];
                for (var o in e) r.push(o + "=" + e[o]);
                return r.join(t)
            },
            appendParamsToUrl: function (e, t) {
                return -1 < e.indexOf("?") ? e += "&" + f.object2string(t) : e += "?" + f.object2string(t), e
            },
            removeUrlParams: function (e) {
                if ("string" == typeof e) {
                    var t = document.createElement("a");
                    return t.href = e, t.protocol + "//" + t.host + t.pathname
                }
            },
            getRelativeUrl: function (e) {
                if ("string" == typeof e) {
                    var t, r = document.createElement("a");
                    return r.href = e, t = r.pathname && "string" == typeof r.pathname ? r.pathname : "", "//" + r.host + ("/" !== t[0] ? "/" + t : t)
                }
            },
            loadCss: function (e) {
                var t, r;
                r = "[object Array]" === Object.prototype.toString.call(e) ? (t = e[0], e[1]) : void(t = e);
                var o = this;
                if (r) {
                    var i = Txplayer.$.Deferred();
                    return o.loadCssSingle(t).done(function () {
                        o.loadCssSingle(r).done(function () {
                            i.resolve()
                        }).fail(function (e) {
                            i.reject(e)
                        })
                    }).fail(function (e) {
                        i.reject(e)
                    }), i
                }
                return o.loadCssSingle(t)
            },
            loadCssSingle: function (e) {
                var n = Txplayer.$.Deferred(),
                    a = 1,
                    o = !1,
                    i = f.getRelativeUrl(e);
                return Txplayer.$('link[rel="stylesheet"]').each(function (e, t) {
                    var r = t.href;
                    if (r && -1 < r.indexOf(i)) return !(o = !0)
                }), o ? n.resolve() : function r(o) {
                    var i = document.createElement("link");
                    i.rel = "stylesheet", i.type = "text/css", i.onload = function () {
                        n.resolve()
                    }, i.onerror = function (e) {
                        var t;
                        3 <= a ? n.reject(e) : (a++, i.parentNode.removeChild(i), (t = {})["__t" + a] = +new Date, r(f.appendParamsToUrl(o, t)))
                    }, i.href = o, Txplayer.$("head")[0].appendChild(i)
                }(e = f.appendParamsToUrl(e, {
                    _: window.Txplayer && Txplayer.dataset.ts || +new Date
                })), n
            },
            getDefaultPosterByVid: function (e) {
                return "//shp.qpic.cn/qqvideo_ori/0/{vid}_{index}/0".replace("{vid}", e).replace("{index}", "496_280")
            },
            getOriginURL: function (e) {
                return "string" != typeof e ? e : e.replace(/\?.+/g, "")
            },
            loadScript: function (e) {
                (e = e || {}).onsuccess = e.onsuccess || function () {};
                var r, t, o = document.createElement("script"),
                    i = document.getElementsByTagName("head")[0],
                    n = /^(?:loaded|complete|undefined)$/;
                e.url && (r = f.getOriginURL(e.url), t = function (e) {
                    var t;
                    if (Txplayer.dataset.loadScriptDefer && Txplayer.dataset.loadScriptDefer[r] && Txplayer.dataset.loadScriptDefer[r].constructor === Array)
                        for (; 0 < Txplayer.dataset.loadScriptDefer[r].length;) "function" == typeof (t = Txplayer.dataset.loadScriptDefer[r].shift()) && t(e)
                }, Txplayer.dataset.loadScriptDefer && Txplayer.dataset.loadScriptDefer[r] && Txplayer.dataset.loadScriptDefer[r].constructor === Array && Txplayer.dataset.loadScriptDefer[r].length ? Txplayer.dataset.loadScriptDefer[r].push(e.onsuccess) : (Txplayer.dataset.loadScriptDefer[r] = [e.onsuccess], o.async = "async", o.src = e.url, o.charset = "utf-8", e.crossorigin && o.setAttribute("crossorigin", "anonymous"), o.onload = o.onerror = o.onreadystatechange = function () {
                    n.test(o.readyState) && (o.onload = o.onerror = o.onreadystatechange = null, t(!(o = null)))
                }, o.onerror = function () {
                    o.onload = o.onerror = o.onreadystatechange = null, o = null, t(!1)
                }, i.appendChild(o)))
            },
            getFlashVersion: function () {
                var e = Txplayer.dataset.flashVersion;
                if ("0.0.0" != e) return e;
                var t = null,
                    r = null,
                    o = [],
                    i = "Shockwave Flash",
                    n = navigator,
                    a = "application/x-shockwave-flash";
                if (Txplayer.util.browser.ie) try {
                    (t = new ActiveXObject("ShockwaveFlash.ShockwaveFlash")) && (r = t.GetVariable("$version")) && (r = r.split(" ")[1].split(","), o = [parseInt(r[0], 10), parseInt(r[1], 10), parseInt(r[2], 10)])
                } catch (e) {} else void 0 !== n.plugins && "object" == s(n.plugins[i]) && (!(r = n.plugins[i].description) || void 0 === n.mimeTypes && n.mimeTypes[a] && !n.mimeTypes[a].enabledPlugin || (r = r.replace(/^.*\s+(\S+\s+\S+$)/, "$1"), o[0] = parseInt(r.replace(/^(.*)\..*$/, "$1"), 10), o[1] = parseInt(r.replace(/^.*\.(.*)\s.*$/, "$1"), 10), o[2] = /[a-zA-Z]/.test(r) ? parseInt(r.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0));
                return e = o.join(".")
            },
            compareVersion: function (e, t) {
                e = String(e).split("."), t = String(t).split(".");
                try {
                    for (var r = 0, o = Math.max(e.length, t.length); r < o; r++) {
                        var i = isFinite(e[r]) && Number(e[r]) || 0,
                            n = isFinite(t[r]) && Number(t[r]) || 0;
                        if (i < n) return -1;
                        if (n < i) return 1
                    }
                } catch (e) {
                    return -1
                }
                return 0
            },
            isFlashFit: function () {
                return -1 < this.compareVersion(this.getFlashVersion(), "10.0")
            },
            getJsonpCallbackName: function (e) {
                return ["txplayerJsonpCallBack", e, parseInt(1e6 * Math.random())].join("_")
            },
            getStdfrom: function (e, t) {
                if (t && t.platId && this.platformMap[t.platId]) return this.platformMap[t.platId].stdfrom;
                if (e && "70201" == e) return "v1104";
                if (e && "70901" == e) return "v1103";
                if (e && "3670201" == e) return "v1105";
                if (e && "40201" == e) return "v1107";
                if (e && "570201" == e) return "v1005";
                if (e && "5230201" == e) return "v1008";
                if (e && "5410201" == e) return "v1012";
                if (e && "700201" === e) return "v1015";
                var r = "view.inews.qq.com" === location.hostname;
                return -1 < location.hostname.indexOf("caixin.com") ? "v1093" : Txplayer.util.mobile || "ke.qq.com" !== location.hostname ? Txplayer.util.os.iphone || Txplayer.util.os.ipod ? r ? "v3110" : "v3010" : Txplayer.util.os.ipad ? r ? "v4110" : "v4010" : Txplayer.util.os.android ? Txplayer.util.os.tablet ? "v6010" : r ? "v5110" : "v5010" : Txplayer.util.browser.IEMobile ? "v7010" : "v1010" : "v1101"
            },
            getDeviceId: function () {
                var e = navigator.userAgent;
                return f.os.ipad ? 1 : f.os.windows ? /Touch/i.test(e) ? 8 : /Phone/i.test(e) ? 7 : 2 : f.os.android ? f.mobile ? 3 : 5 : f.os.iphone ? 4 : f.os.mac ? 9 : 10
            },
            getBusinessId: function () {
                if (f.browser.wechat) return 6;
                if (f.browser.mqq) return 17;
                var e, t, r = "";
                !/^http(s?):\/\/v\.qq\.com\/(iframe\/txp|txp\/iframe)/.test(location.href) || window == top || "" !== (e = document.referrer) && ((t = document.createElement("a")).href = e, r = t.hostname, t = null), "" === r && (r = document.location.hostname || document.location.host);
                for (var o = [{
                        r: /(\w+\.)?weixin\.qq\.com$/i,
                        v: 6
                    }, {
                        r: /^(v|film)\.qq\.com$/i,
                        v: 1
                    }, {
                        r: /^news\.qq\.com$/i,
                        v: 2
                    }, {
                        r: /(\w+\.)?qzone\.qq\.com$/i,
                        v: 3
                    }, {
                        r: /(\w+\.)?t\.qq\.com$/i,
                        v: 5
                    }, {
                        r: /^3g\.v\.qq\.com$/i,
                        v: 8
                    }, {
                        r: /^m\.v\.qq\.com$/i,
                        v: 10
                    }, {
                        r: /3g\.qq\.com$/i,
                        v: 12
                    }], r = r.toLowerCase(), i = 0, n = o.length; i < n; i++) {
                    var a = o[i];
                    if (a.r.test(r)) return a.v
                }
                return 7
            },
            getPlatform: function () {
                return 1e4 * f.getBusinessId() + 100 * f.getDeviceId() + 1
            },
            getDeviceCode: function () {
                var e = 0;
                return f.os.iphone ? e = 2 : f.os.ipad ? e = 3 : f.os.android && f.phone && (e = 1), e
            },
            getPlatformCode: function () {
                var e = 0;
                return f.browser.wechat ? e = 1 : f.browser.mqq ? e = 2 : f.browser.mqqbrowser && (e = 3), e
            },
            isQQBuLuoHost: function () {
                return !(!Txplayer.util.browser.MQQClient || "xiaoqu.qq.com" !== window.location.hostname && "buluo.qq.com" !== window.location.hostname)
            },
            isSupportApp: function () {
                return !!(f.os.iphone || f.os.ipod || f.os.ipad) || !!f.os.android
            },
            getMobileVideoPosterByVid: function (e, t) {
                var r = ["496", "360", "228"];
                var o = r[t] ? r[t] : "0";
                return "//puui.qpic.cn/vpic_cover/".concat(e, "/").concat(e, "_hz.jpg/").concat(o)
            },
            getPcVideoPosterByVid: function (e) {
                return this.getMobileVideoPosterByVid(e, -1)
            },
            getHostNameByUrl: function (e) {
                e = e || location.href;
                var t = document.createElement("a");
                return t.href = e, t.hostname
            },
            getQQFromCookie: function () {
                var e = f.cookie.get("luin") || f.cookie.get("uin");
                return e = e && e.replace(/\D/g, "").replace(/^0+/, "")
            },
            createGUID: function (e) {
                e = e || 32;
                for (var t = "", r = 1; r <= e; r++) {
                    t += Math.floor(16 * Math.random()).toString(16)
                }
                return t
            },
            getSessionData: function (e) {
                try {
                    if (window.sessionStorage) return window.sessionStorage[e]
                } catch (e) {}
            },
            setSessionData: function (e, t) {
                try {
                    window.sessionStorage && (window.sessionStorage[e] = t)
                } catch (e) {}
            },
            delSessionData: function (e) {
                try {
                    if (window.sessionStorage) return window.sessionStorage.removeItem(e)
                } catch (e) {}
            },
            getData: function (e) {
                var t = "";
                try {
                    window.localStorage && (t = window.localStorage[e])
                } catch (e) {}
                return t
            },
            setData: function (e, t) {
                try {
                    window.localStorage && (window.localStorage[e] = t)
                } catch (e) {}
            },
            delData: function (e) {
                try {
                    window.localStorage && window.localStorage.removeItem(e)
                } catch (e) {}
            },
            isSupportM3u8: function () {
                var e = document.createElement("video"),
                    t = ["application/x-mpegURL", "audio/mpegurl", "vnd.apple.mpegURL", "application/vnd.apple.mpegURL"],
                    r = !1;
                if ("function" == typeof e.canPlayType)
                    for (var o = 0, i = t.length; o < i; o++)
                        if (e.canPlayType(t[o])) {
                            r = !0;
                            break
                        } return e = null, r
            },
            isSupportChromeHls: function (e) {
                if ("1" === this.getUrlParam("debugp2p")) return !0;
                var t = !1;
                e && (t = !!e.official);
                var r = e && -1 < this.inArray(["10201", "70201", "3670201", "10901", "70901", "40201"], "" + e);
                window.MediaSource = window.MediaSource || window.WebKitMediaSource;
                var o = window.SourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer,
                    i = !o || o.prototype && "function" == typeof o.prototype.appendBuffer && "function" == typeof o.prototype.remove,
                    n = window.MediaSource && "function" == typeof window.MediaSource.isTypeSupported && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
                return (t || r) && n && i
            },
            isSupportSafariHls: function (e) {
                return e && -1 < this.inArray(["10201", "70201", "3670201", "10901", "70901", "40201"], "" + e) && f.os.mac && f.browser.safari && 0 <= f.compareVersion(f.browser.safari.version, 7)
            },
            isSupportMP4: function () {
                if (f.os.windows && f.browser.pcqqlive && 50171110 <= f.browser.pcqqlive.version) return !0;
                var e = document.createElement("video");
                return "function" == typeof e.canPlayType && ("probably" == e.canPlayType('video/mp4; codecs="avc1.42E01E"') || "probably" == e.canPlayType('video/mp4; codecs="avc1.58A01E"') || "probably" == e.canPlayType('video/mp4; codecs="avc1.4D401E"') || "probably" == e.canPlayType('video/mp4; codecs="avc1.64001E"'))
            },
            isSupportSVG: function () {
                return !(!document.implementation || !Txplayer.$.isFunction(document.implementation.hasFeature)) && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")
            },
            isSupportMute: function () {
                return !Txplayer.util.ios && !Txplayer.util.mobile
            },
            isUseH5Type: function () {
                return f.mobile && !f.os.ipad
            },
            canUseTxplayerHTML5: function () {
                return !(!f.browser.ie || "edge" !== f.browser.ie.version) || !(f.browser.ie && f.compareVersion(f.browser.ie.version, "10.0") < 0) && !!f.isSupportMP4()
            },
            getDomNodeOffsetInPage: function (e) {
                for (var t = e.offsetLeft, r = e.offsetTop, o = e.offsetParent; null !== o;) t += o.offsetLeft, r += o.offsetTop, o = o.offsetParent;
                return {
                    x: t,
                    y: r
                }
            },
            whenWechatIsReady: function (e) {
                var t = Txplayer.$.Deferred(),
                    r = e.timeout || 5e3;
                return Txplayer.util.browser.wechat && ("undefined" != typeof WeixinJSBridge && WeixinJSBridge.on ? t.resolve() : (document.addEventListener("WeixinJSBridgeReady", function () {
                    t.resolve()
                }), setTimeout(function () {
                    t.reject()
                }, r))), t
            },
            getMainHostName: function () {
                var e = window.location.hostname || window.location.host,
                    t = location.host.split(".");
                return 1 < t.length && (e = t.slice(t.length - 2).join(".")), e
            },
            getUrlParam: function (e, t) {
                t = t || document.location.toString();
                var r = new RegExp("(^|&|\\\\?)" + e + "=([^&]*)(&|$|#)"),
                    o = null;
                return (o = t.match(r)) ? o[2] : ""
            },
            getAdChannelId: function (e) {
                var t = "";
                return /ptag=wx\.search/i.test(location.href) ? 64 : e && e.hasOwnProperty("chid") && "" != e.chid ? e.chid : (/(.*\.)3g\.qq\.com$/i.test(window.location.hostname) ? t = 13 : /(.*\.)?v\.qq\.com$/i.test(window.location.hostname) || f.browser.qqlive ? t = f.browser.wechat && f.mobile ? 180 : 0 : f.browser.wechat && -1 < window.location.href.indexOf("/x/qqnews/") ? t = 3 : f.browser.mqq && -1 < window.location.href.indexOf("/x/qqnews/") ? t = 10 : f.browser.qqnews && (t = 2), t)
            },
            insert2Array: function (e, t, r) {
                if (t > r.length) return r;
                var o = r.slice(0, t),
                    i = r.slice(t, r.length);
                return [].concat(o, e, i)
            },
            formatPlayTime: function (e) {
                if ("string" == typeof e && (e = parseInt(e)), "number" == typeof e) {
                    e = parseInt(e);

                    function t(e) {
                        return e < 10 ? "0" + e : e
                    }
                    var r = parseInt(e / 3600),
                        o = parseInt((e - 3600 * r) / 60),
                        i = parseInt(e - 3600 * r - 60 * o);
                    return 0 === r ? [t(o), t(i)].join(":") : [r, t(o), t(i)].join(":")
                }
            },
            dateFormat: function (e, t) {
                e = e || "yyyy-MM-dd hh:mm:ss";
                var r = {
                    "M+": (t = t || new Date).getMonth() + 1,
                    "d+": t.getDate(),
                    "h+": t.getHours(),
                    "m+": t.getMinutes(),
                    "s+": t.getSeconds(),
                    "q+": Math.floor((t.getMonth() + 3) / 3),
                    S: t.getMilliseconds()
                };
                for (var o in /(y+)/.test(e) && (e = e.replace(RegExp.$1, (t.getFullYear() + "").substr(4 - RegExp.$1.length))), r) new RegExp("(" + o + ")").test(e) && (e = e.replace(RegExp.$1, 1 == RegExp.$1.length ? r[o] : ("00" + r[o]).substr(("" + r[o]).length)));
                return e
            },
            isTencentDomain: function (e) {
                if ("qq.com" === (e = e || document.domain)) return !0;
                var t = e.split(".");
                return !!(t && 2 < t.length) && ("qq" === t[t.length - 2] && "com" === t[t.length - 1])
            },
            isVqqOrFilmqq: function () {
                return "v.qq.com" === location.hostname || "film.qq.com" === location.hostname
            },
            loadPlugins: function (e, s, l, c) {
                var u, o, t;

                function p() {
                    var r, o, i, e, t, n;

                    function a(e) {
                        function t() {
                            if (1 <= i) return f.showError("plugin load failed", o), s && s.msg && s.msg.broadcast && (s.msg.broadcast("reportPluginLoadError", {
                                name: r,
                                url: o,
                                requestStartTime: n
                            }), s.dataset && !s.dataset.errorCodeOfStep5 && -1 < f.inArray(["HdPlayer", "HdPlayerControl", "HtmlFrame", "v4HdPlayer", "v4HdPlayerControl", "H5HtmlFrame", "H5Player", "H5PlayerControl"], r) && (e = "62", Txplayer.util.os.windows && (e = "61"), "h5" !== s.config.playerType && "h5tiny" !== s.config.playerType || (e = "64"), s.dataset.errorCodeOfStep5 = e + "200.10002", s.msg.broadcast("reportPluginLoadError", {
                                name: r,
                                url: o,
                                requestStartTime: n,
                                step: 50,
                                bossid: 4501,
                                code: s.dataset.errorCodeOfStep5
                            })), Txplayer.util.localLog("PLUGINS_LOAD_ERROR", {
                                name: r,
                                url: o
                            })), p(), 0;
                            var e;
                            i++, a()
                        }
                        o && -1 === o.indexOf("_ts=") && (-1 < o.indexOf("?") ? o += "&_ts=" + Txplayer.dataset.ts || !1 : o += "?_ts=" + Txplayer.dataset.ts || !1), f.loadScript({
                            url: o,
                            crossorigin: !!e,
                            onsuccess: function (e) {
                                e ? (d(r), "TxpCreativePlayer" === r && (Txplayer.dataset.isReadyPlugins.push(r), s.msg && s.msg.broadcast && s.msg.broadcast("pluginReady", {
                                    name: r
                                }), s.userMsg && s.userMsg.broadcast && s.userMsg.broadcast("pluginReady", {
                                    name: r
                                }))) : t()
                            }
                        })
                    }
                    0 !== u.length ? (r = u.shift(), i = 0, e = s.config && s.config.loadPluginCrossOrigin, t = r.toLowerCase() + ".js", n = +new Date, Txplayer && Txplayer.hashMaps && Txplayer.hashMaps[t] && (t = Txplayer.hashMaps[t]), l && l.hasOwnProperty(r) && l[r].url && (o = l[r].url, e = !1), o = o || Txplayer.dataset.jsBasePath + "plugins/" + t, Txplayer.plugins.hasOwnProperty(r) ? d(r) : "TxpCreativePlayer" === r ? (o = "//vm.gtimg.cn/tencentvideo/txpv5/creative/plugins/txp-creative-player." + Txplayer.appVersion + ".js", void 0 !== window.TxpCreativePlayer ? (d(r), Txplayer.dataset.isReadyPlugins.push(r), s.msg && s.msg.broadcast && s.msg.broadcast("pluginReady", {
                        name: r
                    }), s.userMsg && s.userMsg.broadcast && s.userMsg.broadcast("pluginReady", {
                        name: r
                    })) : a(e)) : a(e)) : c()
                }

                function d(e) {
                    Txplayer.dataset.pluginsLoadTime = Txplayer.dataset.pluginsLoadTime || [], Txplayer.dataset.pluginsLoadTime.push(e + ":" + Txplayer.util.dateFormat("yyyy-M-d h:m:s:S")), (t = function (t) {
                        var r;
                        if (!Txplayer.plugins.hasOwnProperty(t)) return !1;
                        l[t] ? s.pluginConfig = l[t] : s.pluginConfig = {};
                        try {
                            o["_" + t] || (o["_" + t] = new Txplayer.plugins[t](s), Txplayer.dataset.isReadyPlugins.push(t), s.msg && s.msg.broadcast && s.msg.broadcast("pluginReady", {
                                name: t
                            }), s.userMsg && s.userMsg.broadcast && s.userMsg.broadcast("pluginReady", {
                                name: t
                            }))
                        } catch (e) {
                            r = e.message, f.showError("JS\u6709\u5f02\u5e38:" + t, r), f.log(e.stack), s.msg.broadcast && s.msg.broadcast("reportError", {
                                msg: r,
                                code: Txplayer.define.reportCode.JS_ERROR,
                                stack: e.stack
                            })
                        } - 1 == t.indexOf("HtmlFrame") && function (i, n, a) {
                            i && (i.addDestroyToPlugin = function () {
                                var o = this.context.superMsg || this.context.msg;
                                o.on("destroyPlugin", function (e, t) {
                                    var r;
                                    e && e !== n || ("function" === Txplayer.$.type(i.remove) && i.remove(), i && i.dataset && (i.dataset.moduleApis || i.dataset.privateApis || i.dataset.eventsList) && (i.dataset.moduleApis && Txplayer.$.each(i.dataset.moduleApis, function (e, t) {
                                        o.off(e)
                                    }), i.dataset.privateApis && Txplayer.$.each(i.dataset.privateApis, function (e, t) {
                                        o.off(e)
                                    }), i.dataset.eventsList && Txplayer.$.each(i.dataset.eventsList, function (e, t) {
                                        o.off(e)
                                    })), i && i.dataset && Txplayer.$.each(i.dataset, function (e, t) {
                                        /_TIMER/.test(e) && t && (clearInterval(t), clearTimeout(t))
                                    }), r = f.eventSuffix + i.context.dataset.playerId, $(window).off(r), $("body").off(r), $(document).off(r), "function" == typeof i.destroy && i.destroy(), Object.keys(i).forEach(function (e) {
                                        return delete i[e]
                                    }), delete a["_" + n])
                                })
                            }, i.addDestroyToPlugin())
                        }(o["_" + t], t, o);
                        return o["_" + t]
                    }(e)) && t.done && t.fail ? t.done(function () {
                        p()
                    }) : p()
                }
                l = l || {}, c = c || function () {}, f.isArray(e) ? s ? (u = (e = f.filterByArray(e, s && s.config && s.config.removePluginsList ? s.config.removePluginsList : [])).slice(0), o = this, p()) : f.showError("loadPlugins error", "context\u662f\u5fc5\u8981\u53c2\u6570") : f.showError("loadPlugins error", "plugins\u7684\u53c2\u6570\u5e94\u8be5\u662f\u6570\u7ec4")
            },
            getUniqueMsgKey: function (e) {
                return e + "." + f.createGUID()
            },
            getTxVideoPageURLByVid: function (e, t, r) {
                if (t = "0" != t ? "_" + t : "", !e) return "";
                var o = "//v.qq.com/page/" + e.substr(0, 1) + "/" + e.substr(e.length - 2, 1) + "/" + e.substr(e.length - 1, 1) + "/" + e + t + ".html";
                return r && (o += "?start=" + parseInt(r)), o
            },
            getBrowserBrand: function () {
                var e = Txplayer.util.browser,
                    t = "";
                return e.qqbrowser ? t = "qqbrowser" : e.chrome ? t = "chrome" : e.firefox ? t = "firefox" : e.safari ? t = "safari" : e.ie && (t = e.ie.version ? (e.ie.version += "", "ie" + e.ie.version.split(".").shift()) : "ie"), t
            },
            xss: function (e) {
                return "string" != typeof e ? e : e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/\'/g, "&apos;")
            },
            isInScreen: function (e) {
                if (f.mobile) return !1;
                var t = Txplayer.$(window),
                    r = {
                        top: t.scrollTop(),
                        left: t.scrollLeft()
                    };
                r.right = r.left + t.width(), r.bottom = r.top + t.height();
                var o, i = Txplayer.$(e),
                    n = i.offset(),
                    a = window.Zepto ? (o = i.width(), i.height()) : (o = i.outerWidth(), i.outerHeight());
                return n.right = n.left + o, n.bottom = n.top + a, !(r.right < n.left || r.left > n.right || r.bottom < n.top || r.top > n.bottom)
            },
            getPageVisibilityAttribute: function () {
                var e = "hidden",
                    t = "visibilitychange";
                return void 0 !== document.hidden ? (e = "hidden", t = "visibilitychange") : void 0 !== document.msHidden ? (e = "msHidden", t = "msvisibilitychange") : void 0 !== document.webkitHidden && (e = "webkitHidden", t = "webkitvisibilitychange"), {
                    hidden: e,
                    visibilityChange: t
                }
            },
            addPageVisibilityChangeEvent: function (e) {
                var t = this.getPageVisibilityAttribute();
                Txplayer.$(document).on(t.visibilityChange, function () {
                    e && e(!!document[t.hidden])
                })
            },
            isPageHidden: function () {
                var e = this.getPageVisibilityAttribute();
                return document[e.hidden]
            },
            getPTAG: function () {
                for (var e, t = this.getUrlParam, r = this.getDomainOfURL, o = Txplayer.$, i = this.cookie, n = document.location.toString().toLowerCase(), a = "", s = ["ptag", "adtag", "pgv_ref"], l = 0, c = s.length; l < c && !(a = t(s[l], n)); l++);
                if (!a) try {
                    a = sessionStorage.getItem("ptag")
                } catch (e) {}
                return a || (e = r(document.referrer)) && -1 === o.inArray(e, ["v.qq.com", "film.qq.com", "m.v.qq.com"]) && (a = e.replace(/\./g, "_")), a = a || i.get("ptag")
            },
            getDomainOfURL: function (e) {
                if (void 0 === e || null == e || "" == e) return "";
                var t = document.createElement("a");
                return t.href = e, t.hostname
            },
            getProtocolOfURL: function (e) {
                e = e || location.href, (r = document.createElement("a")).href = e;
                var t = r.protocol.replace(":", ""),
                    r = null;
                return t
            },
            getTimeStampStr: function (e) {
                e = e || 10;
                var t = parseInt(+new Date) + "";
                if (t.length === e) return t;
                if (t.length > e) return t.substring(0, e);
                for (var r = e - t.length; 0 < r;) t = "0" + t, r--;
                return t
            },
            extend: function () {
                var e = arguments;
                if (!(e.length <= 1)) {
                    if (2 === e.length) {
                        for (var t in e[1]) e[0][t] = e[1][t];
                        return e[0]
                    }
                    for (var r = e.length - 1, o = e.callee; 0 < r; r--) e[r - 1] = o(e[r - 1], e[r]);
                    return e[0]
                }
            },
            inArray: function (e, t) {
                var r = -1;
                if ("object" === s(e) && e.constructor === Array && e.length)
                    for (var o = 0, i = e.length; o < i; o++)
                        if (e[o] === t) {
                            r = o;
                            break
                        } return r
            },
            isArray: function (e) {
                return "object" === s(e) && e.constructor === Array
            },
            param: function (e) {
                var t = [];
                for (var r in e) t.push(r + "=" + e[r]);
                return t.join("&")
            },
            getUin: function (e) {
                var t, r = this.cookie.get("skey"),
                    o = (this.cookie.get("lskey"), "");
                return "" == r ? 0 : ("" == (o = this.cookie.get("uin")) && e && (o = this.cookie.get("luin")), t = parseInt(o.replace(/^o0*/g, ""), 10), isNaN(t) || t <= 1e4 ? 0 : t)
            },
            getParams: function (e) {
                for (var t, r, o = e.indexOf("?"), i = e.substring(o + 1), n = /\w+=[^&]+/g, a = {}; null !== (t = n.exec(i));) 2 <= (r = t[0].split("=")).length && (a[r.shift()] = r.join("="));
                return a
            },
            removeArrayItem: function (e, t, r) {
                return void 0 === r && (r = 1), "object" !== s(e) || e.constructor !== Array || t < 0 || e.splice(t, r), e
            },
            filterByArray: function (e, t) {
                if (!f.isArray(e) || !Txplayer.util.isArray(e)) return e;
                for (var r = [], o = 0, i = e.length; o < i; o++) - 1 === f.inArray(t, e[o]) && r.push(e[o]);
                return r
            },
            trigger: function (e, t) {
                var r;
                if (!window.jQuery || !jQuery().trigger) return document.createEventObject ? (r = document.createEventObject(), e.fireEvent("on" + t, r)) : ((r = document.createEvent("HTMLEvents")).initEvent(t, !0, !0), !e.dispatchEvent(r));
                jQuery(document).trigger("TxPlayerJSBrageReady")
            },
            getPlayerPageUrl: function () {
                var t = "";
                if (top !== window) try {
                    t = top.location.href
                } catch (e) {
                    t = document.referrer
                } else t = location.href;
                return t
            },
            getTopFrameUrl: function () {
                var t = "";
                if (top !== window) try {
                    t = top.location.href
                } catch (e) {
                    t = document.referrer
                } else t = window.location.href;
                return t
            },
            getReportUA: function () {
                var e = navigator.userAgent;
                return e = e && e.replace(/\$/g, " ").replace(/\,/g, " ")
            },
            getFormatUA: function () {
                var e = "other";
                return f.browser.qqlive && (f.os.iphone ? e = "iphone_qqlive" : f.os.android && (e = "aphone_qqlive")), e
            },
            formatDownloadSpeed: function (e) {
                return "number" != typeof e || (e < 0 && (e = 0), 1024 < e ? e = parseInt(10 * e / 1024) / 10 + "MB/s" : e += "KB/s"), e
            },
            platformMap: {
                qzone_feed: {
                    platform: "30201",
                    stdfrom: "v1106"
                },
                beijing2022: {
                    platform: "2270201",
                    stdfrom: "v1004"
                }
            },
            getPcPlatformId: function (e) {
                if (f.mobile) return "11001";
                if (e.platId && this.platformMap[e.platId]) return this.platformMap[e.platId].platform;
                if (f.isNews()) return "20701";
                if (e && "coolOpen" == e.originalPlayerType) return "3670201";
                if (e.eduext || "260001" === e.authfrom) return f.mobile ? "261001" : "260201";
                if (f.inWhichDomain("sportscom")) return "40201";
                if (f.inWhichDomain("kuaibao")) return "570201";
                if (f.inWhichDomain("wegame")) return "5230201";
                if (f.testTopUrl("lol")) return "700201";
                var t = !e.official;
                return f.os.windows ? t ? "70201" : "10201" : f.os.mac ? t ? "70901" : "10901" : t ? 70901 : 10901
            },
            getUTCTime: function () {
                var e = new Date,
                    t = 60 * e.getTimezoneOffset() * 1e3;
                return e.setTime(e.getTime() + t), e.getTime()
            },
            localTimeStr2UTC: function (e) {
                if ("number" !== Txplayer.$.type(e)) return e;
                var t = new Date,
                    r = 60 * t.getTimezoneOffset() * 1e3;
                return t.setTime(e + r), t.getTime()
            },
            getLoginID: function () {
                var e = Txplayer.util.cookie.get("main_login");
                Txplayer.util.getQQFromCookie() && (Txplayer.util.cookie.get("skey") || Txplayer.util.cookie.get("lskey")) && (e = "qq");
                var t = "",
                    r = "";
                return "wx" == e ? (e = "wxid", t = Txplayer.util.cookie.get("openid"), r = Txplayer.util.getQQFromCookie()) : "qq" == e && (t = Txplayer.util.getQQFromCookie(), r = Txplayer.util.cookie.get("openid")), {
                    mainLogin: e,
                    logintype: {
                        qq: 1,
                        wx: 2
                    } [e] || 0,
                    loginId: t,
                    loginIdEx: r
                }
            },
            random: function (e, t) {
                return parseInt(Math.random() * (e - t) + t)
            },
            realRandom: function (e, t) {
                return Math.floor(Math.random() * (t + 1 - e)) + e
            },
            isNewsPlugin: function () {
                return "m.v.qq.com" == window.location.host && -1 < window.location.href.indexOf("/x/qqnews/")
            },
            isNews: function () {
                return "view.inews.qq.com" === window.location.hostname
            },
            getChance: function (e) {
                return this.realRandom(1, 100) <= e
            },
            getP2pConfig: function (e) {
                var r = [];
                return Txplayer.$.each(e.dataset.filmVideoData[0].urlArray, function (e, t) {
                    r.push(t.url || "")
                }), {
                    playerVer: e.dataset.testVer,
                    guid: e.dataset.guid,
                    isCharge: e.dataset.isNeedPay,
                    osVer: f.os,
                    broVer: f.browser,
                    platform: e.dataset.platform,
                    qq: Txplayer.util.getQQFromCookie(),
                    wx: Txplayer.util.cookie.get("openid"),
                    fp2p: e.dataset.getinfoJSON.fp2p,
                    keyID: e.dataset.getinfoJSON.vl.vi[0].keyid,
                    resolution: e.dataset.currentDefinitionFormat,
                    urls: r
                }
            },
            isChrome56WithBugOfMp4: function (e) {
                return !e.dataset.useHls && (e.dataset && e.dataset.filmVideoData && 1 < e.dataset.filmVideoData.length && f.browser.chrome && 0 < f.compareVersion(f.browser.chrome.version, "56.0.2924.10"))
            },
            tpl: function (e, r) {
                return e.replace(/\$\{(\w+)\}/g, function (e, t) {
                    return r[t] || e
                })
            },
            pluginNameToV4: function (e, t) {
                if (t = t || [], 0 != (e = e || []).length && 0 != t.length)
                    for (var r = 0, o = t.length; r < o; r++) {
                        var i = e.indexOf(t[r].replace(/v4/, "")); - 1 < i && (e[i] = t[r])
                    }
            },
            isInIframe: function () {
                try {
                    return window.self !== window.top
                } catch (e) {
                    return !0
                }
            },
            inNewIframe: function () {
                return /http(s)?:\/\/v\.qq\.com\/txp\/iframe\/player\.html/.test(location.href)
            },
            getHostname: function (e) {
                var t = document.createElement("a");
                return t.href = e, t.hostname
            },
            testTopUrl: function (e) {
                var t = "";
                try {
                    t = location.href.replace(location.search, ""), this.isInIframe() && (t = this.removeUrlParams(top.location.href || ""))
                } catch (e) {}
                var r = {
                    lol: /https?:\/\/lol\.qq\.com\/client\/lcu\/page(.*)/
                };
                return !(!r[e] || !t) && r[e].test(t)
            },
            inWhichDomain: function (e) {
                if (!e) return !1;
                var t = {
                        kuaibao: ["kuaibao.qq.com", "m.gamefeeds.qq.com", "kandian.qq.com", "mcdn.kandian.qq.com"],
                        tencentcom: ["sports.qq.com", "ent.qq.com", "fashion.qq.com", "v.sports.qq.com", "kbs.sports.qq.com", "astro.fashion.qq.com", "vlike.qq.com", "news.qq.com", "society.qq.com", "v.ent.qq.com", "v.fashion.qq.com", "digi.tech.qq.com", "nbachina.qq.com", "view.news.qq.com", "edu.qq.com", "tech.qq.com", "auto.qq.com", "health.qq.com", "sport.qq.com", "finance.qq.com", "cd.qq.com", "new.qq.com", "sh.qq.com", "gd.qq.com"],
                        qzone: ["cm.qzs.qq.com", "cn.qzs.qq.com", "cnc.qzs.qq.com", "ctc.qzs.qq.com", "os.qzs.qq.com", "qzs.qq.com", "shn.photo.qq.com", "qzone.qq.com", "user.qzone.qq.com", "h5.qzone.qq.com"],
                        keqqcom: ["ke.qq.com"],
                        yqqcom: ["y.qq.com"],
                        wegame: ["www.wegame.com.cn", "www.wegamex.com.hk", "www.wegame.com", "plat.tgp.qq.com", "game.tgp.qq.com", "developer.wegame.com", "developer.wegame.com.cn"],
                        gamecom: ["cf.qq.com", "lpl.qq.com", "lol.qq.com", "plat.tgp.qq.com"],
                        sportscom: ["m.sports.qq.com", "sports.qq.com", "v.sports.qq.com", "kbs.sports.qq.com"],
                        qqcom: /\.qq\.com$/
                    },
                    r = t[e];
                if (!r) return !1;
                var o = location.hostname;
                if (this.isInIframe()) try {
                    o = window.top && window.top.location.hostname
                } catch (e) {}
                return "qqcom" === e ? t[e].test(o) : -1 < this.inArray(r, o)
            },
            safariDisableAutoPlay: function () {
                var e = location.hostname;
                if (this.isInIframe()) try {
                    e = window.top && window.top.location.hostname
                } catch (e) {}
                return this.os.mac && this.browser.safari && 1 <= this.compareVersion(this.browser.safari.version, "11.0") && -1 === this.inArray(["v.qq.com", "ke.qq.com", "y.qq.com", "fudao.qq.com"], e)
            },
            browserDisableAutoPlay: function () {
                var e = window.AudioContext || window.webkitAudioContext,
                    t = Txplayer.util.browser,
                    r = Txplayer.util.compareVersion;
                if (Txplayer.util.os.mac && t.safari) return Txplayer.util.safariDisableAutoPlay();
                if (!Txplayer.util.mobile && e && t.chrome && 1 <= r(t.chrome.version, "66.0") && "suspended" === (new e).state) return !0;
                return !1
            },
            getVideoType: function () {
                var e = "";
                return "v.qq.com" === location.hostname && (window.COVER_INFO && window.COVER_INFO.typeid ? e = +window.COVER_INFO.typeid : window.VIDEO_INFO && window.VIDEO_INFO.type && (e = +window.VIDEO_INFO.type)), e
            },
            validVid: function (e) {
                return !e.match(/\W/) && !e.match(/_/) && 11 == e.length
            },
            isPageSupportStopAutoPlay: function () {
                var e = location.protocol + "//" + location.hostname + location.pathname,
                    t = /^http(s?):\/\/v\.qq\.com\/error\.html/.test(e),
                    r = /^http(s?):\/\/v\.qq\.com\/x?\/?(channel)?\/?(movie|sports|finance|news|tech)\/?$/.test(e),
                    o = /^http(s?):\/\/film\.qq\.com\/$/.test(location.href);
                return r || o || t
            },
            preGetMacClientInfo: function (e) {
                function t(t) {
                    try {
                        window.TenvideoJSBridge.callHandler("getSystemInfo", {}, function (e) {
                            e && Txplayer.util.browser.macqqlive && (Txplayer.util.browser.macqqlive.version = e.clientVersion, Txplayer.util.browser.macqqlive.deviceUuid = e.deviceUuid, t && t({
                                version: e.clientVersion,
                                guid: e.deviceUuid
                            }))
                        })
                    } catch (e) {}
                }
                if (Txplayer.util.os.mac && Txplayer.util.browser.macqqlive) try {
                    window.TenvideoJSBridge && window.TenvideoJSBridge.callHandler ? t(e) : document.addEventListener("onTenvideoJSBridgeReady", function () {
                        window.TenvideoJSBridge && window.TenvideoJSBridge.callHandler && t(e)
                    })
                } catch (e) {}
            },
            getPcClientGuid: function () {
                try {
                    if (Txplayer.util.os.windows && window.external && "function" == typeof window.external.GetGUID) return window.external.GetGUID() || "";
                    if (Txplayer.util.os.mac && Txplayer.util.browser.macqqlive) return Txplayer.util.browser.macqqlive.deviceUuid || ""
                } catch (e) {}
            },
            getPcPlatform: function () {
                return Txplayer.util.browser.pcqqlive ? "pc_client" : Txplayer.util.browser.macqqlive ? "mac_client" : "web"
            },
            getQQLiveDeviceInfo: function (e) {
                function t(o) {
                    window.TenvideoJSBridge.invoke("getDeviceInfo", null, function (e) {
                        if ("string" == typeof e) try {
                            e = JSON.parse(e)
                        } catch (e) {}
                        var t, r = e.result;
                        r ? (t = ["omgid=" + (r.omgid || ""), "systemVersion=" + (r.systemVersion || "")], o(t.join("&"))) : o()
                    })
                }
                Txplayer.util.mobile && Txplayer.util.browser.qqlive ? window.TenvideoJSBridge && TenvideoJSBridge.invoke ? t(e) : document.addEventListener("onTenvideoJSBridgeReady", function () {
                    window.TenvideoJSBridge && TenvideoJSBridge.invoke && t(e)
                }) : e()
            },
            imageReport: function (e) {
                var t = document.createElement("img");
                t.style.width = 0, t.style.height = 0, document.body.appendChild(t), t.src = e, document.body.removeChild(t)
            },
            xhrReport: function (e) {
                var t = e.url || "";
                /^http(s)?:/.test(t) || (t = location.protocol + t), -1 === t.indexOf("_dc") && (t += "&_dc=" + Math.random());
                var r = new XMLHttpRequest;
                r.open(e.method || "POST", t), r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), e.withCredentials && (r.withCredentials = !0), r.send(Txplayer.$.param(e.data))
            },
            localLog: function (e, t) {
                if (window._txplayerlocalLogs && "function" == typeof window._txplayerlocalLogs.addLog) try {
                    window._txplayerlocalLogs.addLog(e, t)
                } catch (e) {}
            },
            getPayUrl: function (e, t, r, o) {
                if ("qc.vip.qq.com" != window.location.hostname && "cdn.vip.qq.com" != window.location.hostname) return "ad" == e ? "//film.qq.com/weixin/upay.html?aid=V0$$4:1" : "1080" == e ? "//film.qq.com/weixin/upay.html?aid=V0$$4:8" : void 0;
                var i = "//film.qq.com/weixin/upay.html?hlwactid=HLW_7354&aid=V0$$11:42";
                return "ad" == e ? i += "$4:1" : "1080" == e && (i += "$4:8"), i += t ? "$6:" + t : "", i += r ? "$5:" + r : "", i += "ios" == o ? "$2:8002" : "$2:8001"
            },
            isSupportEme: !1,
            supportEmeAsync: function (e) {
                var t = this,
                    r = !(!this.os.android && !this.os.ios);
                if (this.mobile || r || e) t.isSupportEme = !1;
                else if (t.hasWidevineL3Risk()) this.isSupportEme = !1;
                else {
                    var o = "txp-spteme",
                        i = void 0 !== window.navigator.requestMediaKeySystemAccess && (void 0 !== window.MediaKeys || void 0 !== window.WebKitMediaKeys || void 0 !== window.MSMediaKeys);
                    if (i) try {
                        navigator.requestMediaKeySystemAccess("com.widevine.alpha", [{
                            initDataTypes: ["cenc"],
                            audioCapabilities: [{
                                robustness: "SW_SECURE_CRYPTO",
                                contentType: 'audio/mp4;codecs="mp4a.40.2"'
                            }],
                            videoCapabilities: [{
                                robustness: "SW_SECURE_CRYPTO",
                                contentType: 'video/mp4;codecs="avc1.42E01E"'
                            }]
                        }]).then(function (e) {
                            t.isSupportEme = !0, t.setData(o, t.isSupportEme)
                        }).catch(function (e) {
                            t.isSupportEme = !1, t.setData(o, t.isSupportEme)
                        })
                    } catch (e) {
                        t.isSupportEme = !1, t.setData(o, t.isSupportEme)
                    } else t.isSupportEme = !1, t.setData(o, t.isSupportEme);
                    i && window.Promise && t.supportHDCP()
                }
            },
            hasWidevineL3Risk: function () {
                return this.browser.chrome && this.compareVersion(this.browser.chrome.version, "89") < 0
            },
            supportHDCP: function () {
                var t = this;
                t.v4log("Requesting Widevine system access..."), navigator.requestMediaKeySystemAccess("com.widevine.alpha", [{
                    initDataTypes: ["cenc"],
                    audioCapabilities: [{
                        robustness: "SW_SECURE_CRYPTO",
                        contentType: 'audio/mp4;codecs="mp4a.40.2"'
                    }],
                    videoCapabilities: [{
                        robustness: "SW_SECURE_CRYPTO",
                        contentType: 'video/mp4;codecs="avc1.42E01E"'
                    }]
                }]).then(function (e) {
                    return e.createMediaKeys()
                }).then(function (e) {
                    return t.v4log("Getting HDCP status..."), "getStatusForPolicy" in e ? e.getStatusForPolicy({
                        minHdcpVersion: "2.0"
                    }) : window.Promise.reject("HDCP Policy Check API is not available.")
                }).then(function (e) {
                    return "usable" !== e ? window.Promise.reject(e) : (t.isSupportHDCP = !0, void t.v4log("> HDCP is available for 2.0"))
                }).catch(function (e) {
                    t.isSupportHDCP = !1, t.v4log("Argh! " + e)
                })
            },
            fetch: function (e) {
                var t = this,
                    r = {
                        method: "GET",
                        mode: "cors"
                    };
                return e.credentials && (r.credentials = e.credentials), window.fetch(e.url, r).then(function () {}, function () {
                    throw new Error("ERROR!")
                }).catch(function () {
                    t.requestViaImage(e.url)
                })
            },
            requestViaImage: function (e) {
                var t = document.createElement("img");
                t.onerror = t.onload = function () {
                    t = null
                }, t.src = e
            }
        }, "xhrReport", function (e) {
            var t = e.url || "";
            /^http(s)?:/.test(t) || (t = location.protocol + t), -1 === t.indexOf("_dc") && (t += "&_dc=" + Math.random());
            var r = new XMLHttpRequest;
            r.open(e.method || "POST", t), r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), e.withCredentials && (r.withCredentials = !0), r.send(Txplayer.$.param(e.data))
        }), i(o, "strongReport", function (e) {
            this.xhrReport(e)
        }), i(o, "getBossRpt2AttaUrl", function (e, t) {
            var r = {
                4298: ["z4900004298", "4973349567"],
                2865: ["z3000002865", "4135796792"],
                4501: ["z1500004501", "6599262818"]
            } [e];
            return r ? "//h.trace.qq.com/bosskv?attaid=".concat(r[0], "&token=").concat(r[1]).concat(t || "") : null
        }), o),
        n = r(7),
        a = r(8),
        l = r(9);
    n.call(f), f.report = a, f.PAGE_VIDEO_TYPE = l, f.isIE10 = !!(f.browser.ie && 0 <= f.compareVersion(f.browser.ie.version, "10.0")), e.exports = f
}, function (e, t, r) {
    var o, i, n, a, s, l, c = r(0),
        u = r(11),
        p = {
            version: "v4",
            autoplay: !1,
            autoPlayInMute: !0,
            browserDisableAutoPlay: !1,
            usePreviewDomain: !1,
            enableStopButton: !1,
            playerType: "",
            enForcePlayerType: !1,
            videoType: "vod",
            vid: "",
            cid: "",
            columnId: "",
            containerId: "",
            channelId: "",
            width: "0",
            height: "0",
            showPoster: !0,
            isUsePlayinline: !0,
            isUseWebkitPlayinline: !0,
            isUseAirplay: !0,
            isUseCrossOrigin: !1,
            loadPluginCrossOrigin: !1,
            isUsePreload: !c.mobile,
            isUseControl: !1,
            isUseHtml5UI: !0,
            hideControlUI: !1,
            isShowDurationLimit: !0,
            isHtml5UseFakeFullScreen: !0,
            isContinuePlay: !1,
            pauseBanner: !1,
            downloadBanner: !1,
            recommendBanner: !1,
            followBanner: !1,
            extendPluginsMap: {
                vod: {
                    chromehls: "v.qq.com" === location.hostname ? ["Barrage"] : [],
                    safarihls: "v.qq.com" === location.hostname ? ["Barrage"] : []
                }
            },
            muted: !1,
            volume: 50,
            disableCacheVolume: !1,
            loop: !1,
            settings: {
                HtmlFrame: {
                    subPlugins: c.isIE10 ? ["IEPolyfill"] : []
                },
                TouchControlPanel: {
                    subPlugins: ["TouchProgress", "v4UiControlPlay", "TouchPlayNext", "TouchSelectVidsBtn", "UiShowTime", "TouchDefinition", "TouchSpeed"]
                },
                TouchPlayer: {
                    subPlugins: ["TouchShadow"]
                },
                UiControl: {
                    subPlugins: c.mobile ? ["UiProgress", "UiControlPlay", "UiPlayNext", "UiShowTime", "UiWindowFullScreen", "UiLogo"] : ["UiProgress", "UiNormalPoint", "UiControlPlay", "UiPlayNext", "UiLoopPlay", "UiShowTime", "UiDuration", "UiBarrageBtn", "UiOnlyWatch", "UiSubtitleBtn", "EndRecommend", "UiDefinition", "UiSpeed", "UiLanguage", "UiVolume", "UiPreview", "UiPreviewList", "UiPreviewAd", "UiSettings", "UiBrowserFullScreen", "UiWindowFullScreen", "UiLogo", "UiBuyPlayPoint"]
                },
                H5UiControl: {
                    subPlugins: (l = ["UiControlPlay", "UiShowTime", "H5UIProgress", "H5HdBanner", "H5Defn", "H5UiFullScreen"], c.os.ios && l.unshift("H5PlaybackRate"), l)
                },
                UiSettings: {},
                HdPlayer: {
                    subPlugins: ["UiShadow"]
                },
                v4HdPlayer: {
                    subPlugins: ["UiShadow"]
                },
                H5Player: {
                    subPlugins: ["UiShadow"]
                },
                HlsPlayer: {
                    subPlugins: ["UiShadow"]
                },
                v4HlsPlayer: {
                    subPlugins: ["UiShadow"]
                },
                H5PlayerAd: {
                    url: c.getUrlParam("debugcreative") ? "//ca.gtimg.com/adplugin/js/adplayer.js" : ""
                },
                TxpCreativePlayer: {
                    url: (s = c.getUrlParam("debugcreative")) ? "//vm.gtimg.cn/tencentvideo/txpv5/creative/plugins/txp-creative-player." + s + "js" : ""
                }
            },
            removePluginsList: [],
            isNeedPay: !1,
            playStartTime: 0,
            skipPrelude: !0,
            useConnectionPlay: !1,
            connectionPlayTime: 0,
            hideControlOnPlaying: !0,
            otherVideoLink: "http://v.qq.com/",
            useComboService: !0,
            showLogo: "v.qq.com" !== location.hostname,
            hideLoadingSlogan: !1,
            hideDefnVipLogo: !1,
            hideDefaultWatermark: !1,
            hideCopyUrl: !1,
            logoActionToVindex: !1,
            showTitle: !1,
            showToggleSideBar: !1,
            show1080p: !!c.isVqqOrFilmqq(),
            globalRetryTimes: 4,
            keyRetryTimes: 3,
            nextVid: !1,
            flashWmode: "opaque",
            flashvar: {},
            flashplayerUrl: "",
            showBrowserFullScreen: top === window && "v.qq.com" == location.hostname,
            showSettings: !0,
            showShare: !0,
            showCloseLight: !1,
            showLoopPlay: !1,
            showSmallWindowButton: !1,
            showBullet: !1,
            bulletId: "",
            showImageBullet: !1,
            showBulletInput: !0,
            showFlashBulletInput: !1,
            openBulletDefault: !0,
            showRecommendOnEnd: !0,
            useFlashVIPLayer: -1,
            flashCallFn: function () {},
            showOpenVIPGuide: c.mobile ? function () {} : "",
            chid: "",
            authfrom: "",
            authext: "",
            adPage: "",
            adauthext: "",
            createPlayerAfterCssLoaded: !1,
            showHTML5Switch: (n = 1, "1" != (a = c.getUrlParam("debug")) && "true" != a || (n = 1), n = "v.qq.com" == location.hostname ? n : 0, c.os.mac && (n = 1), n),
            businessId: 0,
            platId: "",
            getHistoryReportParam: function () {
                return !1
            },
            getOuterReportData: function () {
                return this.outerReportData
            },
            outerReportData: "",
            clientReportInfo: {},
            reportRecomm: !0,
            official: (o = !1, i = c.getUrlParam("official"), /^http(s?):\/\/v.qq.com\/x\/(cover|page)\//.test(location.href) && (o = !0), i && (o = "1" == i || "true" == i), o),
            useMiniSkin: !1,
            miniSkinAdaptive: !0
        };
    u[location.hostname] && c.extend(p, u[location.hostname]), e.exports = p
}, function (e, t, r) {
    var o = r(0),
        i = "//vm.gtimg.cn/tencentvideo/txp/style/txp_desktop.css",
        n = {
            cssLoadErrorEvent: "cssLoadError",
            clickErrorReselect: "clickErrorReselect",
            clickErrorGoback: "clickErrorGoback",
            clickSelectVidsBtn: "clickSelectVidsBtn",
            videoTitleClassName: "txp_touch_video_title",
            followStatusChange: "followStatusChange",
            touchHideClass: "txp_touch_hide",
            maxId: 0,
            deferGetPlayerScript: {},
            hideClass: "txp_none",
            showClass: "txp_show",
            btnHoverClass: "txp_hover",
            currentClass: "txp_current",
            jsBasePath: "//vm.gtimg.cn/tencentvideo/txp/js/",
            coreVersion: "v5",
            flashVersion: "0.0.0",
            flashLiveSwf: "//vm.gtimg.cn/minivideo_v1/vd/res/TencentPlayerLive.swf?max_age=86400",
            flashVodSwf: "v.qq.com" !== location.hostname || /^v\.qq\.com\/iframe\/txp\/player\.html/.test(location.href.replace(location.protocol + "//", "")) ? "//imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400" : "//imgcache.qq.com/tencentvideo_v1/playerv3/TencentPlayer.swf?max_age=86400",
            _instance: {},
            documentWebSite: "http://tvp.oa.com/",
            jsApiReady: "TxPlayerJSBrageReady",
            tabindex: 1,
            H5PlayerStyleUrl: {
                html5hd: i,
                nintendo: i,
                touch: "//vm.gtimg.cn/tencentvideo/txp/style/txp-touch.css",
                chromehls: i,
                safarihls: i,
                ipadh5: "//vm.gtimg.cn/tencentvideo/txp/style/txp_pad.css",
                h5: ["//vm.gtimg.cn/tencentvideo/txp/style/txp_mobile.css", "//vm.gtimg.cn/tencentvideo/txp/style/txp_appbar.css"],
                news: ["//vm.gtimg.cn/tencentvideo/txp/style/txp_mobile.css", "//vm.gtimg.cn/tencentvideo/txp/style/txp_appbar_simple.css"],
                h5qq: ["//vm.gtimg.cn/tencentvideo/txp/style/txp_mobile.css", "//vm.gtimg.cn/tencentvideo/txp/style/txp_appbar.css"],
                h5tiny: ["//vm.gtimg.cn/tencentvideo/txp/style/txp_mobile.css", "//vm.gtimg.cn/tencentvideo/txp/style/txp_appbar.css"]
            },
            comboServiceRule: "//vm.gtimg.cn/c/=",
            clickEventName: "click",
            loadScriptDefer: {},
            switchDefinitionTimeout: 0,
            logData: [],
            showreport: "1" === o.getUrlParam("_showreport_"),
            ready: !1,
            loadFlow: [],
            isReadyPlugins: [],
            lastFullScreenId: "",
            localStorageKey: {
                userId: "txp-userid",
                userSetting: "txp-user-setting",
                playTime: "txp-playtime",
                adRfid: "txp-ad-rfid",
                historyPlayTime: "txp-history-playtime",
                historyDefinition: "txp-history-definition",
                volumeHistory: "txp-history-volume",
                adMuteHistory: "txp-ad-history-mute",
                userPlayedTime: "txp-user-playedtime",
                loopPlaySetting: "txp-loop-play-setting",
                onlyWatch: "txp-only-watch",
                unid: "txp-unid",
                retryTimes: "txp-retrytimes",
                bufferTimes: "txp-buffertimes",
                openClientBubble: "txp-client-bubble"
            },
            sessionStorageKey: {
                languageSwitch: "txp-language-switch"
            }
        };
    e.exports = n
}, function (e, t) {
    var r, n, o = (r = {}, n = "$" + +new Date, function (e, t) {
        var i = /\s/.test(e) ? function (e) {
            var t, r = [n],
                o = [
                    []
                ];
            for (t in e) r.push(t), o.push(e[t]);
            return new Function(r, i.$).apply(e, o).join("")
        } : r[e] = r[e] || o(document.getElementById(e).innerHTML);
        return i.$ = i.$ || n + ".push('" + e.replace(/\\/g, "\\\\").replace(/[\r\t\n]/g, " ").split("<%").join("\t").replace(/((^|%>)[^\t]*)'/g, "$1\r").replace(/\t=(.*?)%>/g, "',$1,'").split("\t").join("');").split("%>").join(n + ".push('").split("\r").join("\\'") + "');return " + n, t ? i(t) : i
    });
    e.exports = function (e, t) {
        return t && !t.svgPrefix && (t.svgPrefix = window.Txplayer && window.Txplayer.dataset && window.Txplayer.dataset.svgPrefix || ""), o(e, t)
    }
}, function (e, t, r) {
    r(5), e.exports = r(22)
}, function (e, t, r) {
    r(6);
    var q = r(0),
        j = r(10),
        o = r(2),
        S = r(13),
        _ = r(14),
        U = r(1),
        i = r(16),
        n = r(3),
        C = r(17),
        a = r(18),
        E = j.find$(),
        s = r(19),
        I = r(20);

    function O(e) {
        var t = this;
        window.console && window.console.log && window.console.log("%c\u4eb2\u7231\u7684\u540c\u5b66\u4eec\uff0ctxplayer\u540e\u7eed\u4e0d\u518d\u7ef4\u62a4\u3002\u5982\u6709\u63a5\u5165\u9700\u6c42\u6216\u8005\u529f\u80fd\u4fee\u6539\uff0c\u8bf7\u4f7f\u7528\u6700\u65b0\u7684superplayer\uff0c\u611f\u8c22\u60a8\u7684\u652f\u6301\u3002", "color: #43bb88;font-size: 30px;font-weight: bold;text-decoration: underline;"), q.v4log("new Txplayer", e);
        var o = this,
            r = new _;
        r.__name = "playerMsg", r.setMaxListeners(100), this.userMsg = new _, this.userMsg.__name = "userMsg", this.userMsg.setMaxListeners(100);
        var i = j.filterXSS(q.extend({}, U)),
            i = j.filterXSS(q.extend(i, e)),
            n = q.getUrlParam("playertype");
        "" === n || i.playerType || (i.playerType = n), "1" === q.getUrlParam("debugAutoPlayInMute") && (i.autoPlayInMute = !0);
        var a = "car" === q.getUrlParam("clientType");
        if (a && (i.playerType = "touch"), "touch" === i.playerType && (i.autoPlayInMute = !1), (i.imgRpt || q.inWhichDomain("wegame")) && (O.imgRpt = !0), i.autoplay && 0 != i.volume)
            if (q.browserDisableAutoPlay() && "touch" !== i.playerType) {
                q.v4log("browserDisableAutoPlay", "autoplay is blocked by browser.");
                var s = i.volume;
                if (!i.disableCacheVolume) try {
                    var l = parseInt(q.getData(O.dataset.localStorageKey.volumeHistory));
                    isNaN(l) || 0 === (s = l) && q.v4log("browserDisableAutoPlay", "autoplay is blocked by browser, user's local volume is zero , so autoplay is ok.")
                } catch (e) {}
                0 === s || i.muted || (i.autoPlayInMute ? (i.volume = 0, i.muted = !0) : i.autoplay = !1, i.browserDisableAutoPlay = !0)
            } else i.browserDisableAutoPlay = !1, q.v4log("browserDisableAutoPlay", "autoplay is ok");
        var c, u, p = q.getData(O.dataset.localStorageKey.userSetting);
        p && (c = /\"isSkipPrelude\"/.test(p), u = /\"isSkipPrelude\":1/.test(p), c && (i.skipPrelude = u)), q.preGetMacClientInfo();
        var d, f = i.pluginsMap || S;
        if (q.mobile || (i.version = "v4"), i.pluginsMap) {
            if (f = f[i.videoType], "v4" === i.version && !q.mobile) {
                var h = S.vod.v4.onlyV4 || [];
                for (var y in f) f.hasOwnProperty(y) && f[y] && q.isArray(f[y]) && (q.pluginNameToV4(f[y], h), -1 == f[y].indexOf("TxpCreativePlayer") && f[y].push("TxpCreativePlayer"), -1 == f[y].indexOf("HdAdAdapter") && f[y].push("HdAdAdapter"));
                var m = i.settings || {};
                for (var g in m) m.hasOwnProperty(g) && m[g].subPlugins && q.isArray(m[g].subPlugins) && q.pluginNameToV4(m[g].subPlugins, h)
            }
        } else f = f[i.videoType][i.version];
        "coolOpen" == i.playerType && (i.originalPlayerType = i.playerType), "v4" === i.version && (d = j.useV4P2P(i) && !q.getUrlParam("debugnop2p") && -1 === ["y0033e7f1o8"].indexOf(i.vid) ? O.dataset.ver = "3.5.57" : O.dataset.ver = "3.4.40");
        try {
            i.settings = q.extend({}, U.settings || {}, i.settings || {}, i.extendSettings || {}), i.extendPluginsMap[i.videoType] = e.extendPluginsMap ? q.extend({}, U.extendPluginsMap[i.videoType] || {}, i.extendPluginsMap[i.videoType] || {}) : i.extendPluginsMap[i.videoType]
        } catch (e) {}
        var v = {
            config: i,
            msg: r,
            userMsg: this.userMsg,
            dataset: {
                isCar: a,
                testVer: d,
                playerCreateStartTime: +new Date,
                disableShowHtml5Switch: !i.showHTML5Switch
            },
            userApi: this,
            privateApi: {}
        };
        "touch" !== i.playerType || q.browser.tesla || (v.dataset.useChromeHls = !1, v.dataset.useHls = !0, "chromehls" !== n && i.removePluginsList.push("HlsHelper")), v.dataset.platform = i.platform || q.getPcPlatformId(v.config), v.dataset.sdtfrom = i.sdtfrom || q.getStdfrom(v.dataset.platform, v.config), v.dataset.txplayerAuth = new I, v.dataset.txplayerAuth.setData(v.config.authData), i.businessId && (v.dataset.businessId = i.businessId, "200" == v.dataset.businessId && (v.dataset.businessId = "6"), "201" == v.dataset.businessId && (v.dataset.businessId = "11")), v.config.playerId = j.getPlayerId(i), v.dataset.playerId = v.config.playerId, !i.guid && q.browser.macqqlive ? j.getUserIdForMacClientAsync(function (e) {
            e && e.guid && (v.config.guid = e.guid, v.dataset.guid = v.config.guid)
        }) : (v.config.guid = j.getUserId(i), v.dataset.guid = v.config.guid), v.dataset.flowid = v.dataset.playerId + "_" + v.dataset.platform;
        var w = j.getUnid();
        w && (v.dataset.unid = w), this.getUserId = function () {
            return v.dataset.guid
        }, this.getPlayerId = function () {
            return v.dataset.playerId
        }, this.getPlatform = function () {
            return v.dataset.platform
        }, C.exportsReportApi(v), i.vid && (C.reportTxplayer(v, {
            playType: i.playerType,
            videoType: i.videoType
        }), O.dataset._instance[i.playerId] = this), v.msg.on("reportPluginLoadError", function (e) {
            var t, r, o;
            e && e.name && -1 != q.inArray(["HdPlayer", "HdPlayerControl", "HtmlFrame", "v4HdPlayer", "v4HdPlayerControl"], e.name) && ("4501" != e.bossid || "50" != e.step || (t = v.dataset.$playermod || O.$ && O.$("#" + v.config.containerId)) && t.html && (r = "position:absolute;left:0;top:0;z-index:9999;background:#000;color:#fff;width:100%;height:100%;text-align:center;", o = '<div style="' + (r += "line-height:" + (t.height() || i.height || "100%") + "px;") + '">\u5bf9\u4e0d\u8d77,\u53d1\u751f\u521d\u59cb\u5316\u9519\u8bef,\u60a8\u53ef\u4ee5<a href="javascript:;" style="color:red;" onclick="location.reload()">\u5237\u65b0</a>\u8bd5\u8bd5\u54e6</div>', t.html(o)))
        });
        var b, x, T, P = j.choosePlugins(i, f, v);
        if ("flash" === i.playerType) return window.console.warn("flash player is no longer supported."), O.$("#" + i.containerId).html('<div style="position: absolute;width: 100%;left: 0;top: 40%;color: #fff;text-align: center;">\n            Flash\u64ad\u653e\u5668\u5df2\u7ecf\u7ec8\u6b62\u670d\u52a1\n            <p style="margin: 10px 0;">\u63a8\u8350\u4f7f\u7528\u65b0\u7248 <a style="color: #fff" href="https://www.microsoft.com/zh-cn/edge" target="_blank">Edge</a>\u3001<a style="color: #fff" href="https://www.google.cn/chrome/" target="_blank">Chrome</a>\u3001<a style="color: #fff" href="https://browser.qq.com/" target="_blank">QQ</a> \u7b49\u6d4f\u89c8\u5668</p>\n        </div>').css({
            position: "relative",
            backgroundColor: "#000"
        }), void(this.on = function () {});
        O.dataset.H5PlayerStyleUrl[i.playerType] && O.$ && O.$.Deferred && null !== (b = (x = q.loadCss(O.dataset.H5PlayerStyleUrl[i.bannerNewsUI ? "news" : i.playerType])).catch) && void 0 !== b && b.call(x, function (e) {
            t.userMsg.broadcast(O.dataset.cssLoadErrorEvent, e), -1 !== ["h5", "h5qq", "h5tiny"].indexOf(i.playerType) && O.$("#" + i.containerId).html('<div style="position: absolute;width: 100%;left: 0;top: 40%;color: #fff;text-align: center;">\u6838\u5fc3css\u52a0\u8f7d\u5931\u8d25</div>').css({
                position: "relative",
                backgroundColor: "#000"
            })
        }), "flash" === i.playerType && (O.dataset.flashVersion = q.getFlashVersion()), i.autoplay && i.createOnClick && -1 !== ["h5", "h5tiny"].indexOf(i.playerType) && (v.dataset.emptyVideo = j.insertEmptyVideo(i)), j.installPlugins(o, P, v, i, r, E), this.isApiExist = function (e) {
            return "function" == typeof o[e]
        }, this.on = function (e, t) {
            return "string" != typeof e ? q.error("player.on(evtName, fn), evtName must be a String") : "function" != typeof t ? q.error("player.on(evtName, fn), fn must be a Function") : // set this point to Txplayer instance
                o.userMsg.on(e, function () {
                    t.apply(o, arguments)
                }), this
        }, this.trigger = function (e, t) {
            if ("string" != typeof e) return !1;
            var r = [e, t];
            return E.each(arguments, function (e, t) {
                e < 2 || r.push(t)
            }), o.userMsg.broadcast.apply(o.userMsg, r)
        }, this.off = function (e) {
            return "string" != typeof e ? (q.error('player.off("evtName"):evtName must be a string'), !1) : (o.userMsg.off(e), this)
        }, this.once = function (e, t) {
            return "string" != typeof e ? q.error("player.once(evtName, fn), evtName must be a String") : "function" != typeof t ? q.error("player.once(evtName, fn), fn must be a Function") : // set this point to Txplayer instance
                o.userMsg.once(e, function () {
                    t.apply(o, arguments)
                }), this
        }, location.search && -1 < location.search.indexOf("testcase") && ((T = document.createElement("script")).src = "//vm.gtimg.cn/tencentvideo/module/txp/tools/txplayerLogger.js", document.body.appendChild(T)), q.supportEmeAsync(i.disableEmeCheck)
    }
    O.register = function (e, t) {
        return "string" != typeof e ? (q.error("player.register(pluginName, fn), pluginName must be a String"), this) : "function" != typeof t ? (q.error("player.register(pluginName, fn), fn must be a Function"), this) : void(O.plugins[e] = t)
    }, O.msg = new _, O.msg.setMaxListeners(500), O.dataset = o, O.dataset.debug = 1 == q.getUrlParam("debug"), O.defaultconfig = U, O.errcode = a, O.util = q, O.Events = _, O.plugins = {}, O.$ = E, O.define = {
        reportCode: i
    }, O.appVersion = s, E && (O.$.tmpl = n), window.Txplayer || (window.Txplayer = O), O.dataset.ts = "1666752375076"
}, function (e, t) {
    ! function (e) {
        "use strict";
        var t, r, a, o, i, n, s, l, c, u;

        function p(e) {
            if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
            return e.toLowerCase()
        }

        function d(e) {
            return "string" != typeof e && (e = String(e)), e
        }

        function f(t) {
            var e = {
                next: function () {
                    var e = t.shift();
                    return {
                        done: void 0 === e,
                        value: e
                    }
                }
            };
            return r && (e[Symbol.iterator] = function () {
                return e
            }), e
        }

        function h(t) {
            this.map = {}, t instanceof h ? t.forEach(function (e, t) {
                this.append(t, e)
            }, this) : Array.isArray(t) ? t.forEach(function (e) {
                this.append(e[0], e[1])
            }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
                this.append(e, t[e])
            }, this)
        }

        function y(e) {
            if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
            e.bodyUsed = !0
        }

        function m(r) {
            return new Promise(function (e, t) {
                r.onload = function () {
                    e(r.result)
                }, r.onerror = function () {
                    t(r.error)
                }
            })
        }

        function g(e) {
            var t = new FileReader,
                r = m(t);
            return t.readAsArrayBuffer(e), r
        }

        function v(e) {
            if (e.slice) return e.slice(0);
            var t = new Uint8Array(e.byteLength);
            return t.set(new Uint8Array(e)), t.buffer
        }

        function w() {
            return this.bodyUsed = !1, this._initBody = function (e) {
                if (this._bodyInit = e)
                    if ("string" == typeof e) this._bodyText = e;
                    else if (a && Blob.prototype.isPrototypeOf(e)) this._bodyBlob = e;
                else if (o && FormData.prototype.isPrototypeOf(e)) this._bodyFormData = e;
                else if (t && URLSearchParams.prototype.isPrototypeOf(e)) this._bodyText = e.toString();
                else if (i && a && s(e)) this._bodyArrayBuffer = v(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer]);
                else {
                    if (!i || !ArrayBuffer.prototype.isPrototypeOf(e) && !l(e)) throw new Error("unsupported BodyInit type");
                    this._bodyArrayBuffer = v(e)
                } else this._bodyText = "";
                this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : t && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"))
            }, a && (this.blob = function () {
                var e = y(this);
                if (e) return e;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                return Promise.resolve(new Blob([this._bodyText]))
            }, this.arrayBuffer = function () {
                return this._bodyArrayBuffer ? y(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(g)
            }), this.text = function () {
                var e, t, r, o = y(this);
                if (o) return o;
                if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader, r = m(t), t.readAsText(e), r;
                if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
                    for (var t = new Uint8Array(e), r = new Array(t.length), o = 0; o < t.length; o++) r[o] = String.fromCharCode(t[o]);
                    return r.join("")
                }(this._bodyArrayBuffer));
                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                return Promise.resolve(this._bodyText)
            }, o && (this.formData = function () {
                return this.text().then(x)
            }), this.json = function () {
                return this.text().then(JSON.parse)
            }, this
        }

        function b(e, t) {
            var r, o, i = (t = t || {}).body;
            if (e instanceof b) {
                if (e.bodyUsed) throw new TypeError("Already read");
                this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new h(e.headers)), this.method = e.method, this.mode = e.mode, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0)
            } else this.url = String(e);
            if (this.credentials = t.credentials || this.credentials || "omit", !t.headers && this.headers || (this.headers = new h(t.headers)), this.method = (r = t.method || this.method || "GET", o = r.toUpperCase(), -1 < c.indexOf(o) ? o : r), this.mode = t.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(i)
        }

        function x(e) {
            var i = new FormData;
            return e.trim().split("&").forEach(function (e) {
                var t, r, o;
                e && (r = (t = e.split("=")).shift().replace(/\+/g, " "), o = t.join("=").replace(/\+/g, " "), i.append(decodeURIComponent(r), decodeURIComponent(o)))
            }), i
        }

        function T(e, t) {
            t = t || {}, this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = 200 <= this.status && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new h(t.headers), this.url = t.url || "", this._initBody(e)
        }
        e.fetch || (t = "URLSearchParams" in e, r = "Symbol" in e && "iterator" in Symbol, a = "FileReader" in e && "Blob" in e && function () {
            try {
                return new Blob, !0
            } catch (e) {
                return !1
            }
        }(), o = "FormData" in e, (i = "ArrayBuffer" in e) && (n = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], s = function (e) {
            return e && DataView.prototype.isPrototypeOf(e)
        }, l = ArrayBuffer.isView || function (e) {
            return e && -1 < n.indexOf(Object.prototype.toString.call(e))
        }), h.prototype.append = function (e, t) {
            e = p(e), t = d(t);
            var r = this.map[e];
            this.map[e] = r ? r + "," + t : t
        }, h.prototype.delete = function (e) {
            delete this.map[p(e)]
        }, h.prototype.get = function (e) {
            return e = p(e), this.has(e) ? this.map[e] : null
        }, h.prototype.has = function (e) {
            return this.map.hasOwnProperty(p(e))
        }, h.prototype.set = function (e, t) {
            this.map[p(e)] = d(t)
        }, h.prototype.forEach = function (e, t) {
            for (var r in this.map) this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this)
        }, h.prototype.keys = function () {
            var r = [];
            return this.forEach(function (e, t) {
                r.push(t)
            }), f(r)
        }, h.prototype.values = function () {
            var t = [];
            return this.forEach(function (e) {
                t.push(e)
            }), f(t)
        }, h.prototype.entries = function () {
            var r = [];
            return this.forEach(function (e, t) {
                r.push([t, e])
            }), f(r)
        }, r && (h.prototype[Symbol.iterator] = h.prototype.entries), c = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"], b.prototype.clone = function () {
            return new b(this, {
                body: this._bodyInit
            })
        }, w.call(b.prototype), w.call(T.prototype), T.prototype.clone = function () {
            return new T(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new h(this.headers),
                url: this.url
            })
        }, T.error = function () {
            var e = new T(null, {
                status: 0,
                statusText: ""
            });
            return e.type = "error", e
        }, u = [301, 302, 303, 307, 308], T.redirect = function (e, t) {
            if (-1 === u.indexOf(t)) throw new RangeError("Invalid status code");
            return new T(null, {
                status: t,
                headers: {
                    location: e
                }
            })
        }, e.Headers = h, e.Request = b, e.Response = T, e.fetch = function (r, i) {
            return new Promise(function (o, e) {
                var t = new b(r, i),
                    n = new XMLHttpRequest;
                n.onload = function () {
                    var e, i, t = {
                        status: n.status,
                        statusText: n.statusText,
                        headers: (e = n.getAllResponseHeaders() || "", i = new h, e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                            var t, r = e.split(":"),
                                o = r.shift().trim();
                            o && (t = r.join(":").trim(), i.append(o, t))
                        }), i)
                    };
                    t.url = "responseURL" in n ? n.responseURL : t.headers.get("X-Request-URL");
                    var r = "response" in n ? n.response : n.responseText;
                    o(new T(r, t))
                }, n.onerror = function () {
                    e(new TypeError("Network request failed"))
                }, n.ontimeout = function () {
                    e(new TypeError("Network request failed"))
                }, n.open(t.method, t.url, !0), "include" === t.credentials ? n.withCredentials = !0 : "omit" === t.credentials && (n.withCredentials = !1), "responseType" in n && a && (n.responseType = "blob"), t.headers.forEach(function (e, t) {
                    n.setRequestHeader(t, e)
                }), n.send(void 0 === t._bodyInit ? null : t._bodyInit)
            })
        }, e.fetch.polyfill = !0)
    }("undefined" != typeof self ? self : this)
}, function (e, t) {
    e.exports = function (e) {
        e = (e = e || navigator.userAgent).toLowerCase(), this.browser = {}, this.os = {}, this.phone = {}, this.mobile = !1, -1 < e.indexOf("mobile") && (this.mobile = !0);
        var t, r, o = {
            android_1: /android[\s\/]([\d\.]+)/i,
            android_2: /android/i,
            android_3: /MIDP-/i,
            ipod_1: /iPod\stouch;\sCPU\siPhone\sos\s([\d_]+)/i,
            ipod_100: /iPod.*os\s?([\d_\.]+)/i,
            iphone: /iPhone;\sCPU\siPhone\sos\s([\d_]+)/i,
            iphone_100: /iPhone.*os\s?([\d_\.]+)/i,
            ipad_1: /ipad;\scpu\sos\s([\d_]+)/i,
            ipad_2: /ipad([\d]+)?/i,
            windows: /windows\snt\s([\d\.]+)/i,
            mac: /Macintosh.*mac\sos\sx\s([\d_\.]+)/i,
            linux: /Linux/i,
            nintendo: /Nintendo Switch/i
        };
        for (var i in o)
            if (t = o[i].exec(e)) {
                r = i.replace(/_\d+/, ""), this.os[r] = !0, this.os.name = r, t[1] && (this.os.version = t[1].replace(/_/g, "."));
                break
            }(this.os.iphone || this.os.ipad || this.os.ipod) && (this.os.ios = !0);
        var n, a, s, l = {
            weishi: /WEISHI_([\d\.]+)/i,
            toutiao: /TTWebView\/([\d\.]+)/i,
            wechat: /MicroMessenger\/([\d\.]+)/i,
            ipadqq: /IPadQQ\/([\d\.]+)/i,
            mqq: /qq\/([\d\.]+)/i,
            qzone: /QZONEJSSDK\/([\d\.]+)/i,
            mqqbrowser: /mqqbrowser\/([\d\.]+)/i,
            qqbrowser: /[^m]QQBrowser\/([\d\.]+)/i,
            x5: /tbs\/(\d+)/i,
            uc: /UCBrowser\/([\d\.]+)/i,
            safari_1: /Version\/(([\d\.]+))\sSafari\/[\d\.]+/i,
            safari_2: /Safari\/([\d\.]+)/i,
            firefox: /Firefox\/([\d\.]+)/i,
            opera: /OPR\/([\d\.]+)/i,
            ie_1: /MSIE\s([\d\.]+)/i,
            ie_2: /(trident\/\d\.\d)/i,
            ie_3: /(Edge)\/\d+\.\d+/i,
            weibo: /weibo__([\d\.]+)/i,
            qqnewsAd: /TADChid\/([\d\.]+)/i,
            qqnews: /qqnews\/([\d\.]+)/i,
            qqlive_1: /QQLiveBrowser\/([\d\.]+)/i,
            qqlive_2: /QQLiveHDBrowser\/([\d\.]+)/i,
            kuaibao: /qnreading\/([\d\.]+)/i,
            liebao: /LieBaoFast\/([\d\.]+)/i,
            douban: /com\.douban\.frodo\/([\d\.]+)/i,
            miuibrowser: /MiuiBrowser/i,
            baidu: /baiduboxapp/i,
            browser360: /360browser/i,
            oppobrowser: /OppoBrowser/i,
            chrome_1: /CriOS\/([\d\.]+)/i,
            chrome_2: /Chrome\/([\d\.]+)/i,
            qqdownloader: /qqdownloader\/([\d\.]+)/i,
            nintendo: /NintendoBrowser\/([\d\.]+)/i,
            tesla: /tesla/i
        };
        for (var c in l)
            if (n = l[c].exec(e)) {
                if (a = c.replace(/_\d+/, ""), this.browser[a]) return;
                this.browser[a] = {
                    version: n[1]
                }
            }
        /windows/i.test(e) && /qqlive/i.test(e) && window.external && window.external.GetProtocalVersion && "function" == typeof window.external.GetProtocalVersion && (s = window.external.GetProtocalVersion(), this.browser.pcqqlive = {
            version: s
        }), /mac\sos/i.test(e) && /qqlive_mac/i.test(e) && (this.browser.macqqlive = {}), this.os.android && this.browser.safari && delete this.browser.safari, this.browser.chrome && this.browser.safari && delete this.browser.safari, this.browser.ie && this.browser.ie.version && -1 < this.browser.ie.version.indexOf("trident") && (-1 < this.browser.ie.version.indexOf("6.0") ? this.browser.ie.version = "10" : -1 < this.browser.ie.version.indexOf("5.0") ? this.browser.ie.version = "9" : -1 < this.browser.ie.version.indexOf("4.0") ? this.browser.ie.version = "8" : this.browser.ie.version = "11");
        var u, p = {
            ipod: /iPod/i,
            ipad: /iPad/i,
            iphone: /iPhone/i,
            huawei_1: /HUAWEI([\w_-]+)/i,
            huawei_2: /(CHM-\w+)/i,
            huawei_3: /(HonorChe)/i,
            huawei_4: /HONORPLK/i,
            huawei_5: /(Che\d+-CL\d+)/i,
            huawei_6: /(H\d+-L\d+)/i,
            huawei_100: /HUAWEI/i,
            xiaomi_1: /(HM\sNOTE)/i,
            xiaomi_2: /(HM\s\w+)/i,
            xiaomi_3: /(MI\s\w+)/i,
            xiaomi_4: /(MI-ONE\sPlus)/i,
            xiaomi_5: /(M1)\sBuild/i,
            xiaomi_6: /(HM\d+)/i,
            xiaomi_7: /Xiaomi[\s_]?([\w_]+)/i,
            samsung_1: /(GT-\w+)/i,
            samsung_2: /(SCH-\w+)/i,
            samsung_3: /(SM-\w+)/i,
            vivo: /vivo\s(\w+)/i,
            oneplus: /ONEPLUS-([a-z0-9]+)/i,
            lenovo_1: /Lenovo[\s-]?([\w-]+)/i,
            lenovo_100: /Lenovo/i,
            zte_1: /ZTE\s?(\w+)?/i,
            zte_2: /ZTE/i,
            coolpad_1: /Coolpad\s(\w+)/i,
            coolpad_100: /Coolpad/i,
            oppo_1: /OPPO\s?(\w+)/i,
            oppo_2: /(R7Plus|R8007|R801|R831S|R8205)/i,
            oppo_100: /OPPO/i,
            meizu_1: /(MX\d+)/i,
            meizu_2: /(m\d+\snote)\sBuild/i,
            htc_1: /HTC\s?(\w+)/i,
            htc_100: /HTC/i,
            tcl: /TCL\s(\w+)/i,
            lephone: /lephone\s(\w+)/i,
            lg: /LG[\s-]?(\w+)/i,
            galaxy: /(galaxy\d+)/,
            hisense_1: /Hisense/i,
            hisense_2: /HS-(\w+)/i,
            philips: /Philips\s?(\w+)?/i,
            "\u91d1\u7acb": /(GN\w+)\sBuild/i,
            sonny: /sonny/i,
            "\u5929\u8bed": /K-Touch/i
        };
        for (var d in p)
            if (u = p[d].exec(e)) {
                this.phone.name = d.replace(/_\d+/, ""), u[1] && (this.phone.version = u[1].replace(/^[_-]/gi, ""));
                break
            } this.browser && this.browser.mqq && (this.os.ios || this.os.android) && (this.mobile = !0)
    }
}, function (e, t) {
    var r, o = [],
        i = !1;

    function n(e) {
        if (!Txplayer.dataset.ready) return i || (i = !0, Txplayer.msg && Txplayer.msg.on("ready", function () {
            ! function () {
                if (!Txplayer.dataset.ready) return;
                a()
            }()
        })), void o.push(e);
        r ? o.push(e) : (r = setTimeout(function () {
            a()
        }, 1e3), Txplayer.util.mobile || Txplayer.imgRpt ? Txplayer.util.requestViaImage(e) : Txplayer.util.fetch({
            url: e,
            credentials: "include"
        }).catch(function () {
            a()
        }), function (e) {
            if (e && Txplayer.util && Txplayer.util.getParams && Txplayer.dataset.showreport && window.console && "function" == typeof window.console.table) {
                var t = [],
                    r = Txplayer.util.getParams(e);
                for (var o in r) t.push({
                    key: o,
                    value: decodeURIComponent(r[o])
                });
                r && r.BossId ? window.console.log("%c" + [r.BossId, r.step].join(" -- "), "color: green;") : window.console.log(e), window.console.table(t)
            }
        }(e))
    }

    function a() {
        0 !== o.length ? (clearTimeout(r), r = null, n(o.shift())) : r = null
    }
    e.exports = n
}, function (e, t) {
    e.exports = {
        MOVIE: 1,
        TV: 2,
        CARTOON: 3,
        SPORT: 4,
        ENT: 5,
        GAME: 6,
        RECORD: 9,
        VARIETY: 10,
        WORLD_CUP: 21,
        MUSIC: 22,
        NEWS: 23,
        FINANCE: 24,
        FASHION: 25,
        TRAVEL: 26,
        EDUCATION: 27,
        TECH: 28,
        CAR: 29,
        ESTATE: 30,
        LIFE: 31,
        MICROTEACHING: 37,
        AD: 40,
        SELFIE: 41,
        FUNNY: 43,
        CONF_AND_BUD: 45,
        MICROMOVIE: 46,
        COOPERATION: 50,
        CULTURE: 51,
        YOUTH: 52,
        MOTHER_AND_BABY: 60,
        ORIGINAL: 103,
        SHOOTER: 105,
        CHILDREN: 106
    }
}, function (e, t, r) {
    var c = r(0),
        o = (r(1), r(2)),
        i = r(12);

    function s(e) {
        return "vod" === e.videoType ? c.os.mac ? c.browser.safari && (c.compareVersion(c.browser.safari.version, "9.0") < 0 || c.compareVersion(c.os.version, "10.10") < 0) && c.isFlashFit() || c.browser.firefox && c.compareVersion(c.browser.firefox.version, "48.0") < 0 ? "flash" : c.browser.macqqlive ? "safarihls" : (c.isSupportMP4(), "html5hd") : c.os.windows ? function () {
            if (c.os.windows && c.browser.pcqqlive && 50171110 <= c.browser.pcqqlive.version) return !0;
            if (c.browser.firefox && 0 <= c.compareVersion(c.browser.firefox.version, "48.0")) return !0;
            if (c.browser.opera && 0 <= c.compareVersion(c.browser.opera.version, "40.0")) return !0;
            if (c.browser.chrome && 0 <= c.compareVersion(c.browser.chrome.version, "39.0")) return !0;
            return !!c.isIE10
        }() && c.isSupportMP4() ? "html5hd" : "flash" : c.os.linux ? "html5hd" : c.os.ios ? c.os.ipad && "view.inews.qq.com" !== location.hostname ? "ipadh5" : "h5" : c.os.android ? c.isSupportMP4() ? "h5" : "mp4link" : c.os.nintendo ? "nintendo" : "html5hd" : void 0
    }

    function l(t) {
        var e = c.getData(o.localStorageKey.userSetting),
            r = {};
        if (e) {
            try {
                window.JSON && "function" == typeof JSON.parse ? r = JSON.parse(e) : "function" == typeof Txplayer.$.parseJSON && (r = Txplayer.$.parseJSON(e))
            } catch (e) {
                t.msg.broadcast("reportError", {
                    msg: e.message,
                    code: Txplayer.define.reportCode.JS_ERROR,
                    stack: e.stack
                })
            }
            return r && r.isUseFlash + "" == "0" ? "html5hd" : ""
        }
    }
    e.exports = {
        insertEmptyVideo: function (e) {
            function t(e) {
                var t, r, o;
                e && (r = (t = e.split("="))[0], void 0 === (o = t[1]) && (o = !0), "string" == typeof o && (o = o.replace(/"/g, "")), i.setAttribute(r, o))
            }
            var i = document.createElement("video");
            i.setAttribute("data-role", "txp_video_tag");
            try {
                return function (e) {
                    var t = {
                            isUsePlayinline: ['playsinline="isiPhoneShowPlaysinline" x5-video-player-type="h5-page" t7-video-player-type="inline" '],
                            isUseWebkitPlayinline: ['webkit-playsinline="isiPhoneShowPlaysinline"'],
                            isUseAirplay: "x-webkit-airplay",
                            isUseControl: 'controls="controls"',
                            isUsePreload: ['preload="auto"', 'preload="none"'],
                            isUseCrossOrigin: 'crossOrigin="anonymous"',
                            muted: "muted",
                            isUseIgnore: 'x5-video-ignore-metadata="true"'
                        },
                        r = [];
                    for (var o in t) Txplayer.$.isArray(t[o]) ? !0 === e[o] ? r.push(t[o][0]) : r.push(t[o][1]) : !0 === e[o] && r.push(t[o]);
                    return r
                }(e).forEach(function (e) {
                    e.indexOf(!0) ? e.split(" ").forEach(t) : t(e)
                }), i.style.display = "none", document.body.appendChild(i), i.play().catch(function (e) {
                    c.v4log("insertEmptyVideoCatch", e.message)
                }), i
            } catch (e) {
                c.v4log("insertEmptyVideoErr", e.message)
            }
        },
        filterXSS: function (e) {
            var t = ["title", "volume", "duration", "vid", "containerId"];
            for (var r in e) - 1 < c.inArray(t, r) && (e[r] = c.xss(e[r]));
            return e
        },
        find$: function () {
            var e = "function" == typeof window.Zepto ? window.Zepto : "function" == typeof window.jQuery ? window.jQuery : "function" == typeof window.jq ? window.jq : null;
            return e
        },
        choosePlugins: function (e, t, r) {
            var o, i = !!e.playerType;
            if (!c.mobile && !e.enForcePlayerType) {
                var n = !1;
                try {
                    n = parent.window._TxpIframeInQzoneIfrme
                } catch (e) {}
                c.inNewIframe() && n || !/_fp=f/.test(location.href) && !c.os.linux && "v.qq.com" == location.hostname && (/v.qq.com\/x\/cover|page\//.test(location.href) || /v.qq.com(\/*\w*)\/p\/topic\//.test(location.href)) || (o = l(r))
            }
            if (/_fp=f/.test(location.href)) try {
                window.history.pushState({
                    title: document.title
                }, "", location.href.replace(/\??&?_fp=f/, ""))
            } catch (e) {}
            c.browser.ie && ("edge" === c.browser.ie.version || c.isIE10 || (o = "flash", r.dataset.disableShowHtml5Switch = 1)), o ? e.playerType = o : e.playerType || (e.playerType = s(e)), "html5hd" === e.playerType && (c.isSupportChromeHls(r.dataset.platform) ? e.playerType = "chromehls" : c.isSupportSafariHls(r.dataset.platform) ? e.playerType = "safarihls" : c.isSupportMP4() || (e.playerType = "flash", r.dataset.disableShowHtml5Switch = 1)), "0" !== c.getUrlParam("forcestream") || "chromehls" !== e.playerType && "safarihls" !== e.playerType || (e.playerType = "html5hd"), !i && !o && "html5hd" == e.playerType && c.os.mac && c.browser.qqbrowser && (e.playerType = "flash"),
                function (e) {
                    var t = navigator.userAgent,
                        r = -1 !== location.host.indexOf("m.v.qq.com");
                    if (/COVC/i.test(t) && r) return 1;
                    var o = t.indexOf("MQQBrowser"),
                        i = t.indexOf("Mobile Safari");
                    if (!(o && i && i < o || t.indexOf("Chrome/66.0.3359.126") < 0)) {
                        var n = "h5" == e.playerType && c.os.android,
                            a = ("h5tiny" == e.playerType || "h5" == e.playerType) && c.os.ios,
                            s = c.os.version && 0 < c.compareVersion(c.os.version, "7"),
                            l = c.browser.mqqbrowser && c.browser.mqqbrowser.version && 0 <= c.compareVersion(c.browser.mqqbrowser.version, "7.3");
                        return !!((n || a && s) && l && r && !e.enableHevc && c.browser.chrome)
                    }
                }(e) && (e.playerType = "h5qq"), !c.mobile || "flash" !== e.playerType && "html5hd" !== e.playerType && "chromehls" !== e.playerType && "safarihls" !== e.playerType || (e.playerType = "h5"), "chromehls" !== e.playerType && "safarihls" !== e.playerType || (r.dataset.useHls = !0);
            var a = t[e.playerType];
            return e.extendPluginsMap && e.extendPluginsMap[e.videoType] && e.extendPluginsMap[e.videoType][e.playerType] && (a = a.concat(e.extendPluginsMap[e.videoType][e.playerType])), e.official ? c.isIE10 && e.removePluginsList.push("UiOnlyWatch") : e.removePluginsList.push("UiFavorite", "UiOmSubscribe", "UiLanguage", "UiSettings", "UiBrowserFullScreen", "UiOnlyWatch", "EndRecommend", "UiNormalPoint", "UiBuyPlayPoint"), "nintendo" === e.playerType && e.removePluginsList.push("UiPlayNext", "UiBrowserFullScreen", "UiWindowFullScreen", "UiSpeed"), a = c.filterByArray(a, e.removePluginsList), "mp4link" !== e.playerType && "flash" !== e.playerType && "v4" != e.version && Array.prototype.indexOf && -1 === a.indexOf("H5PlayerAd") && a.push("H5PlayerAd"), "3.5.57" === r.dataset.testVer || c.inWhichDomain("sportscom") ? a.forEach(function (e, t) {
                if (/hlshelper/i.test(e)) return a[t] = "HlsHelperP2PEncrypt", !(r.dataset.useP2P = !0)
            }) : r.dataset.testVer === c.getUrlParam("debugusep2p") ? a.forEach(function (e, t) {
                if (/hlshelper/i.test(e)) return a[t] = "HlsHelperP2PDebug", !(r.dataset.useP2P = !0)
            }) : "3.6.3" === r.dataset.testVer && a.forEach(function (e, t) {
                if (/hlshelper/i.test(e)) return a[t] = "HlsHelperP2PAdaptive", !(r.dataset.useP2P = !0)
            }), a
        },
        installPlugins: i.installPlugins,
        comboService: i.comboService,
        getPlayerId: function (e) {
            return e.pid || c.createGUID()
        },
        getUserId: function (e) {
            var t = e.guid || c.getData(o.localStorageKey.userId);
            return e.guid || !c.browser.pcqqlive && !c.browser.macqqlive || (t = (t = c.getPcClientGuid()) || c.getData(o.localStorageKey.userId)), t || (t = c.createGUID(), c.setData(o.localStorageKey.userId, t)), t
        },
        getUserIdForMacClientAsync: function (t) {
            c.browser.macqqlive && c.preGetMacClientInfo(function (e) {
                t && t(e)
            })
        },
        getUnid: function () {
            return c.getData(o.localStorageKey.unid)
        },
        useV4P2P: function (e) {
            return "0" !== c.getUrlParam("debugp2p") && (("1" === c.getUrlParam("debugp2p") || !c.inNewIframe() && ("v.qq.com" === location.hostname || "film.qq.com" === location.hostname)) && c.isSupportChromeHls({
                official: !0
            }))
        },
        useV4P2PAdaptive: function (e) {
            return -1 < c.inArray(["3q0jq9kvr9wvk2x", "639agzdh10yu2q2", "29ydp7xrml13rxk", "gakoshshys2i1c0", "70d6i1b6s0rtwpy", "lcpwn26degwm7t3", "0hrejqzlvdyr03k", "i8wue9gam2mewxf", "zmtpenihq5z8m75", "ym3zk2afta7lkuw", "0qd517viyiujrr4", "i200hs4ip5a6u7a", "aeuz5ypnru0wxqq", "wqoslotdl4dhza6", "5sxw7i4occhtkt8", "ha7r9z89i9d234y", "033i818h6hqga2i", "zgz8djmyrquyfh3", "70d6i1b6s0rtwpy", "9z88hz9qwugb8p1", "ceusrubximxm0g8", "yoz60y87rdgl1vp", "e7hi6lep1yc51ca", "3q0jq9kvr9wvk2x", "jvhuaf93hh858fs", "t3qd0fliz287tr7", "1wbx6hb4d3icse8", "0rok1fggj7zwsez", "gqvzz2ezmquha4p", "6ql0vqq1huc2kdb", "rpup19lfbuf2skc"], e.cid)
        },
        getVideoType: function () {
            var e = "";
            return "v.qq.com" == location.host && (window.COVER_INFO && window.COVER_INFO.typeid ? e = +window.COVER_INFO.typeid : window.VIDEO_INFO && window.VIDEO_INFO.type && (e = +window.VIDEO_INFO.type)), e
        }
    }
}, function (e, t) {
    e.exports = {
        "www.beijing2022.cn": {
            showLogo: !1,
            hideLoadingSlogan: !0,
            hideDefnVipLogo: !0,
            hideDefaultWatermark: !0,
            hideCopyUrl: !0,
            show1080p: !0,
            official: !1,
            platId: "beijing2022"
        }
    }
}, function (e, t, r) {
    var w = r(0),
        b = r(3),
        x = !1;

    function T(e, t, r, o, i, n) {
        function a() {
            n || (n = "function" == typeof window.Zepto ? window.Zepto : "function" == typeof window.jQuery ? window.jQuery : "function" == typeof window.jq ? window.jq : null) && (x = !0, Txplayer.$ = n, Txplayer.$.tmpl = b), w.loadPlugins.call(e, t, r, o.settings, function () {
                r.dataset.isReady = !0, r.dataset.playerCreateEndTime = +new Date, "flash" !== o.playerType && (e.userMsg.broadcast("ready"), i.broadcast("ready"), Txplayer.dataset.ready ? setTimeout(function () {
                    e.userMsg.broadcast("playerInit")
                }, 100) : (Txplayer.dataset.ready = !0, Txplayer.msg.broadcast("ready"), e.userMsg.broadcast("playerInit")))
            })
        }
        var s;
        n || x ? a() : (s = "/tencentvideo/txp/js/jquery.min.js", w.mobile && (s = "/tencentvideo/txp/js/zepto.min.js"), w.loadScript({
            url: "//vm.gtimg.cn" + s,
            onsuccess: a
        }))
    }
    e.exports = {
        comboService: function (r, o, i, n, a, s) {
            var e, t = [],
                l = [],
                c = [],
                u = 0,
                p = "/tencentvideo/txp/js/plugins/",
                d = !1,
                f = !1,
                h = "/tencentvideo/txp/js/jquery.min.js";

            function y(e) {
                l.push(e)
            }

            function m(e) {
                g && -1 < w.inArray(n.removePluginsList, e) || -1 < w.inArray(n.removePluginsList, e.substr(2)) || t.push(e)
            }
            w.mobile && (h = "/tencentvideo/txp/js/zepto.min.js");
            for (var g = w.isArray(n.removePluginsList), u = 0, v = o.length; u < v; u++) ! function e(t) {
                if ("string" == typeof t && (n.settings[t] && (!n.settings.hasOwnProperty(t) || n.settings[t].url) || m(t), n.settings[t] && w.isArray(n.settings[t].subPlugins)))
                    for (var r = 0, o = n.settings[t].subPlugins.length; r < o; r++) e(n.settings[t].subPlugins[r])
            }(o[u]);
            for (u = 0, v = t.length; u < v; u++) "TxpCreativePlayer" != t[u] ? (w.mobile || "v4" != i.config.version || -1 != w.inArray(["UiControlPlay", "UiVolume", "UiDefinition"], t[u]) && (t[u] = "v4" + t[u]), Txplayer.plugins[t[u]] || (e = t[u].toLowerCase() + ".js", Txplayer.hashMaps && Txplayer.hashMaps[e] && Txplayer.hashMaps[e].replace ? y(Txplayer.hashMaps[e]) : y(e))) : f = !0;
            for (; 0 < l.length;) s || x ? !d && f ? (d = !0, c.push(Txplayer.dataset.comboServiceRule + ["/tencentvideo/txpv5/creative/plugins/txp-creative-player." + Txplayer.appVersion + ".js", p + l.splice(0, 19).join(",")].join(","))) : c.push(Txplayer.dataset.comboServiceRule + p + l.splice(0, 20).join(",")) : (x = !0, c.push(Txplayer.dataset.comboServiceRule + [h, p + l.splice(0, 19).join(",")].join(",")));
            ! function e() {
                if (0 !== c.length) {
                    var t = c.shift();
                    t += "?max_age=604800&_ts=" + Txplayer.dataset.ts, w.loadScript({
                        url: t,
                        crossorigin: !!n.loadPluginCrossOrigin,
                        onsuccess: function () {
                            s || (s = "function" == typeof window.Zepto ? window.Zepto : "function" == typeof window.jQuery ? window.jQuery : "function" == typeof window.jq ? window.jq : null) && (Txplayer.$ = s, Txplayer.$.tmpl = b), e()
                        }
                    })
                } else {
                    if (!n.vid) return;
                    T(r, o, i, n, a)
                }
            }()
        },
        installPlugins: T
    }
}, function (e, t) {
    var r = ["HtmlFrame", "v4HdPlayer", "HdAdAdapter", "TxpCreativePlayer", "UiPoster", "v4H5Report", "v4HdPlayerReport", "UiLoading", "UiLoadingWithAD", "HdPlayerHistory", "v4HdPlayerControl", "DownloadMonitor", "v4UiError", "UiTips", "UiControl", "UiTitle", "HdHotKey", "UiScreenPercent", "UiTrBtnGroup", "UiOverlayPlay", "UiClock", "UiConsole", "UiWaterMark", "UiWaterMarkAction", "UiRightClickMenu", "UiOmSubscribe", "UiUnofficialEndTip", "UiOpenClientBubble", "H5UiSpeedy"],
        o = {
            vod: {
                v4: {
                    html5hd: r,
                    nintendo: ["HtmlFrame", "v4HdPlayer", "HdAdAdapter", "TxpCreativePlayer", "UiPoster", "v4H5Report", "v4HdPlayerReport", "UiLoading", "UiLoadingWithAD", "HdPlayerHistory", "v4HdPlayerControl", "DownloadMonitor", "v4UiError", "UiTips", "UiControl", "UiTitle", "UiScreenPercent", "UiTrBtnGroup", "UiOverlayPlay", "UiClock", "UiConsole", "UiWaterMark", "UiWaterMarkAction", "UiOmSubscribe", "UiUnofficialEndTip", "UiOpenClientBubble"],
                    chromehls: ["HtmlFrame", "v4HdPlayer", "HdAdAdapter", "TxpCreativePlayer", "UiPoster", "v4H5Report", "v4HdPlayerReport", "UiLoading", "UiLoadingWithAD", "HdPlayerHistory", "HlsHelper", "v4HdPlayerControl", "DownloadMonitor", "v4UiError", "UiTips", "UiControl", "UiTitle", "HdHotKey", "UiScreenPercent", "UiTrBtnGroup", "UiPip", "UiOverlayPlay", "UiClock", "UiConsole", "UiWaterMark", "UiWaterMarkAction", "UiRightClickMenu", "UiOmSubscribe", "UiUnofficialEndTip", "UiOpenClientBubble", "H5UiSpeedy"],
                    safarihls: r,
                    ipadh5: ["HtmlFrame", "UiTips", "UiControl", "UiLoading", "H5PlayerAd", "UiPlay", "UiIpadLimit", "HdPlayerReport", "HdPlayerHistory", "UiPoster", "UiError", "H5Player", "H5PlayerControl", "UiWaterMark", "UiWaterMarkAction", "H5UiSpeedy"],
                    h5: ["H5HtmlFrame", "H5Login", "H5UiLoading", "H5UiPlay", "H5UiPoster", "H5MReport", "H5UiLimit", "H5UiSpeedy", "H5UiErrorShow", "H5UILogo", "HdPlayerReport", "H5PlayerAd", "H5Player", "HDSupport", "H5UiControl", "H5PlayerControl", "UiContinuePlay", "H5DownloadBanner", "H5FollowBanner", "H5PauseBanner", "H5FullBanner", "H5TopBanner", "H5RcdBanner", "TinyRcdBanner", "H5LimitBanner", "H5InteractBanner", "H5PageBanner", "H5Downloader"],
                    touch: ["HtmlFrame", "TouchPlayer", "HdAdAdapter", "TxpCreativePlayer", "UiPoster", "v4H5Report", "v4HdPlayerReport", "UiLoading", "HdPlayerHistory", "HlsHelper", "v4HdPlayerControl", "DownloadMonitor", "v4UiError", "UiTips", "TouchControlPanel", "UiTrBtnGroup", "UiConsole", "UiWaterMark", "UiWaterMarkAction", "TouchTopBanner"],
                    h5qq: ["H5HtmlFrame", "H5QQPlayer"],
                    mp4link: ["H5UiMp4link", "H5PlayerControl"],
                    h5tiny: ["H5HtmlFrame", "H5Login", "UiPoster", "H5UiLoading", "H5UiErrorShow", "HdPlayerReport", "H5PlayerAd", "H5Player", "H5PlayerControl", "TinyUiPlay", "H5DownloadBanner", "H5FollowBanner", "TinyRcdBanner", "H5Downloader"],
                    flash: ["HtmlFrame", "FlashPlayer"],
                    tizen: ["TizenLoadingAd", "TizenTV"],
                    miniplayer: [],
                    onlyV4: ["v4H5Report", "v4HdPlayerControl", "v4HdPlayerReport", "v4HdPlayer", "v4UiControlPlay", "v4UiDefinition", "v4UiError", "v4UiVolume"]
                }
            },
            live: {}
        };
    e.exports = o
}, function (e, t, r) {
    var o = r(15),
        l = /debugevent=1/.test(location.href),
        i = {};
    o.prototype.on = function (e, t) {
        if (this.eventMap || (this.eventMap = i), e && "string" == typeof e)
            if (t && t.call && t.constructor === Function) {
                var r = e.split(".");
                i[r[0]] || (i[r[0]] = []);
                var o = void 0 !== r[1] ? r[1] : "_";
                if (-1 === i[r[0]].indexOf(o) && i[r[0]].push(o), this.addListener.call(this, e, t), l) try {
                    -1 < ["onAdOrderDataReady"].indexOf(e) && window.Txplayer && Txplayer.util.log(this.__name + "-on: " + e, arguments.callee.caller)
                } catch (e) {}
            } else window.Txplayer && Txplayer.util.error("on error:listener must be a function" + e);
        else window.Txplayer && Txplayer.util.error("on error:evtName \u4e0d\u5408\u6cd5:" + e)
    }, o.prototype.off = function (e) {
        if (!e) return this;
        if (-1 < e.indexOf(".")) return this.removeAllListeners.call(this, e), this;
        for (name in this._events) name !== e ? name && -1 === name.indexOf(".") || e === name.split(".")[0] && this.removeAllListeners.call(this, name) : this.removeAllListeners.call(this, e);
        return this
    }, o.prototype.broadcast = function (t, e) {
        if (t) {
            if ("string" != typeof t) return this;
            for (var r = [t], o = 0, i = arguments.length; o < i; o++) 0 !== o && r.push(arguments[o]);
            var n = r.slice(0);
            if (-1 < t.indexOf(".")) return this.emit.apply(this, r), this;
            var a, s = this;
            if (this.eventMap && this.eventMap[t] && (0 < (a = this.eventMap[t]).length && a.forEach(function (e) {
                    n[0] = t + (0 === e.indexOf("_") ? "" : "." + e), s.emit.apply(s, n)
                })), l) try {
                -1 < ["onAdOrderDataReady"].indexOf(t) && window.Txplayer && Txplayer.util.log(this.__name + "_broadcast: " + t, e, "onAdOrderDataReady" === t ? arguments.callee.caller : "")
            } catch (e) {}
            return this
        }
        window.Txplayer && Txplayer.util.error("broadcast error:evtName\u4e0d\u80fd\u4e3a\u7a7a:" + t)
    }, o.prototype.setData = function (e, t) {
        e ? t && t.call && t.constructor === Function ? this.addListener.call(this, e, t) : window.Txplayer && Txplayer.util.error("on error:listener must be a function" + e) : window.Txplayer && Txplayer.util.error("on error:evtName\u4e0d\u80fd\u4e3a\u7a7a:" + e)
    }, o.prototype.getData = function (e, t) {
        if ("string" != typeof e) return !1;
        for (var r = {
                data: null,
                async: !1
            }, o = [e, t, r], i = 0, n = arguments.length; i < n; i++) i < 2 || o.push(arguments[i]);
        return this.emit.apply(this, o), r.async ? r.async : r.data
    }, e.exports = o
}, function (e, t, r) {
    "use strict";

    function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e
        } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }
    var i, n = "object" === ("undefined" == typeof Reflect ? "undefined" : o(Reflect)) ? Reflect : null,
        u = n && "function" == typeof n.apply ? n.apply : function (e, t, r) {
            return Function.prototype.apply.call(e, t, r)
        };
    i = n && "function" == typeof n.ownKeys ? n.ownKeys : Object.getOwnPropertySymbols ? function (e) {
        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))
    } : function (e) {
        return Object.getOwnPropertyNames(e)
    };
    var a = Number.isNaN || function (e) {
        return e != e
    };

    function s() {
        s.init.call(this)
    }
    e.exports = s, e.exports.once = function (i, n) {
        return new Promise(function (e, t) {
            function r() {
                void 0 !== o && i.removeListener("error", o), e([].slice.call(arguments))
            }
            var o;
            "error" !== n && (o = function (e) {
                i.removeListener(n, r), t(e)
            }, i.once("error", o)), i.once(n, r)
        })
    }, (s.EventEmitter = s).prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var l = 10;

    function c(e) {
        if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + o(e))
    }

    function p(e) {
        return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners
    }

    function d(e, t, r, o) {
        var i, n, a, s;
        return c(r), void 0 === (n = e._events) ? (n = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== n.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), n = e._events), a = n[t]), void 0 === a ? (a = n[t] = r, ++e._eventsCount) : ("function" == typeof a ? a = n[t] = o ? [r, a] : [a, r] : o ? a.unshift(r) : a.push(r), 0 < (i = p(e)) && a.length > i && !a.warned && (a.warned = !0, (s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit")).name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, console && console.warn)), e
    }

    function f(e, t, r) {
        var o = {
                fired: !1,
                wrapFn: void 0,
                target: e,
                type: t,
                listener: r
            },
            i = function () {
                if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments)
            }.bind(o);
        return i.listener = r, o.wrapFn = i
    }

    function h(e, t, r) {
        var o = e._events;
        if (void 0 === o) return [];
        var i = o[t];
        return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (e) {
            for (var t = new Array(e.length), r = 0; r < t.length; ++r) t[r] = e[r].listener || e[r];
            return t
        }(i) : m(i, i.length)
    }

    function y(e) {
        var t = this._events;
        if (void 0 !== t) {
            var r = t[e];
            if ("function" == typeof r) return 1;
            if (void 0 !== r) return r.length
        }
        return 0
    }

    function m(e, t) {
        for (var r = new Array(t), o = 0; o < t; ++o) r[o] = e[o];
        return r
    }
    Object.defineProperty(s, "defaultMaxListeners", {
        enumerable: !0,
        get: function () {
            return l
        },
        set: function (e) {
            if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
            l = e
        }
    }), s.init = function () {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0
    }, s.prototype.setMaxListeners = function (e) {
        if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
        return this._maxListeners = e, this
    }, s.prototype.getMaxListeners = function () {
        return p(this)
    }, s.prototype.emit = function (e) {
        for (var t = [], r = 1; r < arguments.length; r++) t.push(arguments[r]);
        var o, i = "error" === e,
            n = this._events;
        if (void 0 !== n) i = i && void 0 === n.error;
        else if (!i) return !1;
        if (i) {
            if (0 < t.length && (o = t[0]), o instanceof Error) throw o;
            var a = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
            throw a.context = o, a
        }
        var s = n[e];
        if (void 0 === s) return !1;
        if ("function" == typeof s) u(s, this, t);
        else
            for (var l = s.length, c = m(s, l), r = 0; r < l; ++r) u(c[r], this, t);
        return !0
    }, s.prototype.addListener = function (e, t) {
        return d(this, e, t, !1)
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (e, t) {
        return d(this, e, t, !0)
    }, s.prototype.once = function (e, t) {
        return c(t), this.on(e, f(this, e, t)), this
    }, s.prototype.prependOnceListener = function (e, t) {
        return c(t), this.prependListener(e, f(this, e, t)), this
    }, s.prototype.removeListener = function (e, t) {
        var r, o, i, n, a;
        if (c(t), void 0 === (o = this._events)) return this;
        if (void 0 === (r = o[e])) return this;
        if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete o[e], o.removeListener && this.emit("removeListener", e, r.listener || t));
        else if ("function" != typeof r) {
            for (i = -1, n = r.length - 1; 0 <= n; n--)
                if (r[n] === t || r[n].listener === t) {
                    a = r[n].listener, i = n;
                    break
                } if (i < 0) return this;
            0 === i ? r.shift() : function (e, t) {
                for (; t + 1 < e.length; t++) e[t] = e[t + 1];
                e.pop()
            }(r, i), 1 === r.length && (o[e] = r[0]), void 0 !== o.removeListener && this.emit("removeListener", e, a || t)
        }
        return this
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (e) {
        var t, r = this._events;
        if (void 0 === r) return this;
        if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
        if (0 === arguments.length) {
            for (var o, i = Object.keys(r), n = 0; n < i.length; ++n) "removeListener" !== (o = i[n]) && this.removeAllListeners(o);
            return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this
        }
        if ("function" == typeof (t = r[e])) this.removeListener(e, t);
        else if (void 0 !== t)
            for (n = t.length - 1; 0 <= n; n--) this.removeListener(e, t[n]);
        return this
    }, s.prototype.listeners = function (e) {
        return h(this, e, !0)
    }, s.prototype.rawListeners = function (e) {
        return h(this, e, !1)
    }, s.listenerCount = function (e, t) {
        return "function" == typeof e.listenerCount ? e.listenerCount(t) : y.call(e, t)
    }, s.prototype.listenerCount = y, s.prototype.eventNames = function () {
        return 0 < this._eventsCount ? i(this._events) : []
    }
}, function (e, t) {
    e.exports = {
        JS_ERROR: "3000",
        FLASH_API_ERROR: "3001",
        CGI_ERROR: "3002",
        VIDEO_PLAY_FAIL: "3003",
        VIDEO_NET_LOADING: "3004",
        VIDEO_FENPIAN_ERR: "3005",
        SEEK_ERROR: "3006",
        JS_LOAD_ERR: "3007",
        AD_JS_LOAD_ERR: "3008"
    }
}, function (e, t) {
    function r(e, t) {
        // url += Txplayer.util.param(data);
        // Txplayer.util.report(url);
    }

    function o(e) {
        if (e && e.filename && e.message && -1 !== e.filename.indexOf("//vm.gtimg.cn/tencentvideo/txp/js/")) {
            var t, r, o, i, n, a, s = function () {
                var e;
                if (!(Txplayer && Txplayer.dataset && Txplayer.dataset._instance)) return e;
                for (var t in Txplayer.dataset._instance) {
                    e = Txplayer.dataset._instance[t];
                    break
                }
                return e
            }();
            try {
                s && s.constructor === Txplayer && (t = s.getUserId(), r = s.getPlayerId(), o = s.getVid(), i = s.getPlayerType(), n = s.getVideoType(), a = s.getPlatform())
            } catch (e) {}
            var l = ["line=" + e.lineno, "column=" + e.colno].join(" "),
                c = {
                    version: Txplayer.dataset.ver,
                    uid: t,
                    pid: r,
                    vid: o,
                    player_type: i,
                    video_type: "vod" === n ? 1 : 2,
                    platform: a,
                    url: document.URL,
                    filename: e.filename,
                    sub_version: Txplayer.dataset.flashVersion,
                    error_code: "3000",
                    error_msg: e.message,
                    error_stack: l,
                    file_lastupdate: Txplayer.dataset.lastModify,
                    qq_openid: u(),
                    hc_uin: Txplayer.util.getQQFromCookie(),
                    hc_main_login: Txplayer.util.cookie.get("main_login"),
                    hc_vuserid: Txplayer.util.cookie.get("vuserid"),
                    hc_openid: Txplayer.util.cookie.get("openid"),
                    hc_appid: Txplayer.util.cookie.get("appid"),
                    hc_ua: Txplayer.util.getReportUA()
                };
            Txplayer.util.showInfo("\u9519\u8bef\u4e0a\u62a5", c)
        }
    }

    function u() {
        return Txplayer.util.cookie.get("openid") || Txplayer.util.getQQFromCookie()
    }

    function i(e, t) {
        var r = {
            url: encodeURIComponent(Txplayer.util.getTopFrameUrl()),
            ver: Txplayer.dataset.ver,
            ua: Txplayer.util.getReportUA(),
            iSta: "3537",
            val: 1,
            int1: Txplayer.util.getDeviceCode(),
            int2: Txplayer.util.getPlatformCode(),
            int3: 0,
            int4: 0,
            str1: "",
            str2: Txplayer.dataset.filename,
            str8: Txplayer.util.getUrlParam("mmuin"),
            __tm: Txplayer.util.dateFormat("yyyy-M-d h:m:s:S"),
            hc_openid: Txplayer.util.cookie.get("openid")
        };
        r.vid = e.vid, r.int6 = e.promotionId, r.str4 = e.appCase, r.int5 = e.reportStep, r.str5 = e.str5 || "", r.str6 = Txplayer.util.getUrlParam("openid", Txplayer.util.getTopFrameUrl()), r.str6 = r.str6 || "", r.str3 = e.reportFrom || "", r.str7 = e.guid || "", Txplayer.util.showInfo("AppBanner\u4e0a\u62a5", r)
    }

    function n(e, t) {
        if ("LD" === e.adtype) {
            var r = e.ext_info || "";
            r += ";existblock:" + (TxpCreativePlayer && TxpCreativePlayer.adBlockEnabled ? 1 : 0);
            var o, i = "",
                n = e.step_code;
            if (e.src) try {
                i = 0 != e.step_code && void 0 !== window.btoa ? btoa(e.src) : e.src, r += ";cdn:" + Txplayer.util.getDomainOfURL(e.src)
            } catch (e) {}
            e.step_duration < 0 || (o = function () {
                var e = {
                    name: "",
                    ver: ""
                };
                if (Txplayer.util.browser) {
                    var t = Txplayer.util.browser;
                    for (var r in t)
                        if (t.hasOwnProperty(r)) {
                            var o = t[r];
                            if (o) {
                                e.name = r, e.ver = o.version;
                                break
                            }
                        }
                }
                return e
            }(), t.dataset.flowid, t.dataset.vid, e.adtype, e.step, e.step_duration, e.step_index, window.TxpCreativePlayer && window.TxpCreativePlayer.version || e.version, e.firstview_duration, function () {
                var e = "",
                    t = location.hostname || "",
                    r = location.href;
                try {
                    Txplayer.util.inNewIframe() ? e = "iframe" : (e = t.replace(/\./gi, "_"), /http(s?):\/\/v.qq.com\/x\/(cover|page|)/.test(r) && (e += "_play"))
                } catch (e) {}
            }(), Txplayer.util.getVideoType(), t.dataset.hasCallSetVid, document.URL, e.step_dcode, o.name, o.ver)
        }
    }
    window.addEventListener ? window.addEventListener("error", o) : window.attachEvent && window.attachEvent("onerror", o), e.exports = {
        reportTxplayer: function (e, t) {
            // url += Txplayer.util.param(data);
            // !Txplayer.util.isNewsPlugin && Txplayer.util.report(url);
        },
        reportError: r,
        reportAppBanner: i,
        exportsReportApi: function (a) {
            a.msg.on("reportError", function (e) {}), a.msg.on("reportUsrAction", function (e) {
                var t, r, o, i, n;
                t = e, o = (r = a).config.playerType, i = r.config.videoType, n = {
                    version: Txplayer.dataset.ver,
                    uid: r.dataset.guid,
                    pid: r.dataset.playerId,
                    vid: r.dataset.vid,
                    player_type: o,
                    video_type: "vod" === i ? 1 : 2,
                    platform: r.dataset.platform,
                    usr_action: t.usr_action || "",
                    usr_action_detail: t.usr_action_detail || "",
                    url: document.URL
                }, Txplayer.util.showInfo("\u7528\u6237\u884c\u4e3a\u4e0a\u62a5", n)
            }), a.msg.on("reportGetinfo", function (e) {
                var t, r;
                t = e, (r = a).dataset.guid, r.dataset.platform, Txplayer.util.getQQFromCookie(), r.dataset.vid, new Date, r.dataset.stdfrom, t.filename, t.cdnIp, t.cdnId, t.vkey
            }), a.msg.on("reportAppBanner", function (e) {
                i(e)
            }), a.msg.on("reportLoginUserPlayTime", function (e) {
                ! function (e, t) {
                    e = e || {};
                    var r = t.dataset.txplayerAuth.raw(),
                        o = {
                            version: Txplayer.dataset.ver,
                            pid: t.dataset.guid,
                            vid: t.dataset.vid,
                            cid: t.dataset.cid,
                            level: t.dataset.reportVideoLevel,
                            val: t.dataset.userRealPlayedTime,
                            bi: t.dataset.videoDuration,
                            bt: t.dataset.duration,
                            vt: t.dataset.reportCDNChannelId,
                            step: 5,
                            val1: e.isend ? 1 : 2,
                            platform: 11,
                            url: document.URL,
                            cpay: t.dataset.isNeedPay ? 1 : 0,
                            tpay: t.dataset.userPayStatus,
                            ctime: Txplayer.util.dateFormat("yyyy-MM-dd hh:mm S"),
                            ptime: t.dataset.currentTime,
                            type: t.dataset.reportBusinessType,
                            cmid: t.dataset.guid,
                            ptag: Txplayer.util.getPTAG(),
                            isvip: -1,
                            tpid: t.dataset.videoCategoryId,
                            login_type: r.main_login,
                            uin: Txplayer.util.getQQFromCookie(),
                            vuserid: r.vuserid || Txplayer.util.cookie.get("vuserid"),
                            abi: t.dataset.userTotalPlayedTime
                        };
                    t.config && "function" === Txplayer.$.type(t.config.getUserType) && (o.isvip = 2 == t.config.getUserType() ? 1 : 0),
                        // url += Txplayer.util.param(data);
                        Txplayer.util.showInfo("\u6210\u957f\u4f53\u7cfb\u65f6\u957f\u4e0a\u62a5", o)
                }(e, a)
            }), a.msg.on("reportPluginLoadError", function (e) {
                ! function (e, t) {
                    e = e || {}, Txplayer.util.getLoginID(), t.dataset.platform;
                    var r = {
                            // osver: [Txplayer.util.os.name, Txplayer.util.os.version].join(' '),
                            // playerver: Txplayer.dataset.ver,
                            flowid: t.dataset.flowid
                        },
                        o = {
                            name: e.name || "",
                            ptime: t.dataset.currentTime || 0,
                            stime: e.requestStartTime,
                            etime: +new Date,
                            url: e.url || ""
                        },
                        i = "4564";
                    e.hasOwnProperty("bossid") && (i = e.bossid), "4501" == i && "50" == e.step && (o = {
                        reason: "",
                        code: e.code || "",
                        etime: +new Date
                    }), (r = Txplayer.$.extend(r, {
                        data: JSON.stringify(o)
                    })).step = e.step, e.hasOwnProperty("step") || (r.step = 61);
                    var n = util.getBossRpt2AttaUrl(i, "&");
                    n && (n += Txplayer.$.param(r), Txplayer.util.fetch({
                        url: n,
                        credentials: "include"
                    }))
                }(e, a)
            }), a.msg.on("reportAdInfo", function (e) {
                n(e, a)
            })
        }
    }
}, function (e, t) {
    var r = {};
    r.defaultMsg = r[10001] = r[50] = r[68] = r[71] = r[73] = r[74] = r[76] = r[77] = r[445] = r[444] = "\u554a\u54e6\uff0c\u6ca1\u80fd\u627e\u5230\u4f60\u8981\u7684\u8282\u76ee\u4fe1\u606f~", r[51] = r[52] = r[64] = r[61] = r[62] = r[63] = r[65] = r[66] = r[81] = r[82] = r[84] = r[86] = r["80.10"] = r[94] = "\u554a\u54e6\uff0c\u672c\u6765\u5728\u8fd9\u513f\u7684\u89c6\u9891\u4e0d\u89c1\u4e86~", r[69] = "\u8bf7\u524d\u5f80\u817e\u8baf\u89c6\u9891APP\u6700\u65b0\u7248\u89c2\u770b\u672c\u89c6\u9891", r[80] = r[83] = "\u554a\u54e6\uff0c\u7248\u6743\u539f\u56e0\uff0c\u8be5\u89c6\u9891\u6682\u65f6\u65e0\u6cd5\u64ad\u653e~", r[97] = "\u8bf7\u4f7f\u7528\u817e\u8baf\u89c6\u9891\u624b\u673a\u7aef\u6700\u65b0\u7248\u672c\u89e3\u9501\u89c2\u770b\u672c\u5185\u5bb9", r.getPlatformErrorCode = function (e, t, r) {
        var o = "-",
            i = "-",
            n = "-";
        return r = r || "00", o = Txplayer.util.os.mac ? "62" : Txplayer.util.os.windows ? "61" : "64", "getinfo" === e ? i = "101" : "getkey" === e ? i = "102" : "ad" === e ? i = "215" : "player" === e && (i = "200"), "neterror" === t ? n = "140" : "cgiInnerError" === t ? (n = "13", 2 === (r = r && "" + r).length && (r = "0" + r)) : "h5video" === t ? n = "111" : "aderror" === t && (n = "150"), "aderror" !== t || Txplayer.util.os.windows || Txplayer.util.os.mac || (n = "151"), o + i + "." + n + r
    }, e.exports = r
}, function (e, t) {
    e.exports = "1.0.174"
}, function (e, t, r) {
    var a = r(21);

    function o() {
        this.data = null
    }
    o.prototype.setData = function (e) {
        this.data = e
    }, o.prototype.getInfo = function (e) {
        var t = "",
            r = this.raw();
        if (e && !("qq" != r.main_login || r.access_token && r.vuserid)) return "";
        try {
            t = JSON.stringify(r)
        } catch (e) {}
        return t
    }, o.prototype.ad = function () {
        for (var e = [
                ["opid", "openid"],
                ["appid", "appid"],
                ["atkn", "access_token"],
                ["uid", "vuserid"],
                ["tkn", "vusession"]
            ], t = this.raw(), r = {
                lt: t.main_login || ""
            }, o = 0, i = e.length; o < i; o++) {
            var n = e[o];
            r[n[0]] = t[n[1]] || ""
        }
        return r
    }, o.prototype.adUrlString = function () {
        var e = this.ad(),
            t = [];
        for (var r in e) t.push(r + "=" + e[r]);
        return t.join("&")
    }, o.prototype.raw = function () {
        if (this.data) return this.data;
        var e = {
            main_login: "",
            openid: "",
            appid: "",
            access_token: "",
            vuserid: "",
            vusession: ""
        };
        try {
            var t = a.get("main_login");
            if ("wx" === t || "qq" === t) {
                e.main_login = t;
                for (var r = ["openid", "appid", "access_token", "vuserid", "vusession"], o = 0, i = r.length; o < i; o++) {
                    var n = r[o];
                    "qq" === t && (n = "vqq_" + n), e[r[o]] = a.get(n)
                }
            }
        } catch (e) {}
        return e
    }, e.exports = o
}, function (e, t) {
    e.exports = {
        set: function (e, t, r, o, i) {
            var n, a;
            return i && (n = new Date, (a = new Date).setTime(n.getTime() + 36e5 * i)), document.cookie = e + "=" + t + "; " + (i ? "expires=" + a.toGMTString() + "; " : "") + (o ? "path=" + o + "; " : "path=/; ") + (r ? "domain=" + r + ";" : "domain=" + window.location.host + ";"), !0
        },
        get: function (e) {
            var t = new RegExp("(?:^|;+|\\s+)" + e + "=([^;]*)"),
                r = document.cookie.match(t);
            return r ? r[1] : ""
        },
        del: function (e, t, r) {
            var o = new Date;
            o.setTime(o.getTime() - 1), document.cookie = e + "=; expires=" + o.toGMTString() + ";" + (r ? "path=" + r + "; " : "path=/; ") + (t ? "domain=" + t + ";" : "domain=" + window.location.host + ";")
        }
    }
}, function (e, t) {
    Txplayer.hashMaps = {
        "barrage.js": "barrage.6b96fe.js",
        "barragefloat.js": "barragefloat.49be52.js",
        "downloadmonitor.js": "downloadmonitor.4eb857.js",
        "endrecommend.js": "endrecommend.8dc93a.js",
        "flashplayer.js": "flashplayer.f1c3fd.js",
        "h5defn.js": "h5defn.bcfb59.js",
        "h5downloadbanner.js": "h5downloadbanner.a78dc6.js",
        "h5downloader.js": "h5downloader.733f4c.js",
        "h5followbanner.js": "h5followbanner.016fed.js",
        "h5fullbanner.js": "h5fullbanner.ff2b32.js",
        "h5hdbanner.js": "h5hdbanner.5922b4.js",
        "h5htmlframe.js": "h5htmlframe.13b0de.js",
        "h5interactbanner.js": "h5interactbanner.1aedf0.js",
        "h5limitbanner.js": "h5limitbanner.898988.js",
        "h5login.js": "h5login.9f607f.js",
        "h5mreport.js": "h5mreport.a8f063.js",
        "h5pagebanner.js": "h5pagebanner.86ed43.js",
        "h5pausebanner.js": "h5pausebanner.11b39f.js",
        "h5playbackrate.js": "h5playbackrate.343922.js",
        "h5player.js": "h5player.2b026c.js",
        "h5playerad.js": "h5playerad.dddb62.js",
        "h5playercontrol.js": "h5playercontrol.32955b.js",
        "h5qqplayer.js": "h5qqplayer.049f5c.js",
        "h5rcdbanner.js": "h5rcdbanner.bb98fd.js",
        "h5report.js": "h5report.b54556.js",
        "h5topbanner.js": "h5topbanner.64a29c.js",
        "h5uicontrol.js": "h5uicontrol.5ea387.js",
        "h5uidefnloading.js": "h5uidefnloading.40f7f8.js",
        "h5uierrorshow.js": "h5uierrorshow.67ae43.js",
        "h5uifullscreen.js": "h5uifullscreen.1b4060.js",
        "h5uilimit.js": "h5uilimit.04f2e3.js",
        "h5uiloading.js": "h5uiloading.6498d5.js",
        "h5uilogo.js": "h5uilogo.116aec.js",
        "h5uimp4link.js": "h5uimp4link.37af7d.js",
        "h5uiplay.js": "h5uiplay.48b342.js",
        "h5uiposter.js": "h5uiposter.a653c9.js",
        "h5uiprogress.js": "h5uiprogress.26a067.js",
        "h5uispeedy.js": "h5uispeedy.177a71.js",
        "hdadadapter.js": "hdadadapter.06a44d.js",
        "hdhotkey.js": "hdhotkey.685be6.js",
        "hdplayer.js": "hdplayer.feb2ae.js",
        "hdplayercontrol.js": "hdplayercontrol.dbab86.js",
        "hdplayerhistory.js": "hdplayerhistory.e67a09.js",
        "hdplayerreport.js": "hdplayerreport.ecbed4.js",
        "hdsupport.js": "hdsupport.eb5280.js",
        "hlshelper.js": "hlshelper.16b891.js",
        "hlshelperp2p.js": "hlshelperp2p.4b5dd2.js",
        "hlshelperp2padaptive.js": "hlshelperp2padaptive.aec100.js",
        "hlshelperp2pdebug.js": "hlshelperp2pdebug.1f796a.js",
        "hlshelperp2pencrypt.js": "hlshelperp2pencrypt.733834.js",
        "htmlframe.js": "htmlframe.7b5423.js",
        "iepolyfill.js": "iepolyfill.1970bd.js",
        "playerhistoryreport.js": "playerhistoryreport.b59541.js",
        "tinyrcdbanner.js": "tinyrcdbanner.f9d4ce.js",
        "tinyuiplay.js": "tinyuiplay.f28e55.js",
        "touchcontrolpanel.js": "touchcontrolpanel.b0bac7.js",
        "touchdefinition.js": "touchdefinition.2d35e2.js",
        "touchplayer.js": "touchplayer.8fa42a.js",
        "touchplaynext.js": "touchplaynext.51e15a.js",
        "touchprogress.js": "touchprogress.76870f.js",
        "touchselectvidsbtn.js": "touchselectvidsbtn.444bca.js",
        "touchshadow.js": "touchshadow.7fb563.js",
        "touchspeed.js": "touchspeed.67ca73.js",
        "touchtopbanner.js": "touchtopbanner.9907a3.js",
        "uibarragebtn.js": "uibarragebtn.e2d96e.js",
        "uibrowserfullscreen.js": "uibrowserfullscreen.061121.js",
        "uibuyplaypoint.js": "uibuyplaypoint.e22480.js",
        "uiclock.js": "uiclock.bae7fa.js",
        "uiconsole.js": "uiconsole.de68e7.js",
        "uicontinueplay.js": "uicontinueplay.8834b6.js",
        "uicontrol.js": "uicontrol.f3590f.js",
        "uicontrolplay.js": "uicontrolplay.49ba4f.js",
        "uidefinition.js": "uidefinition.7f09df.js",
        "uidialog.js": "uidialog.20ea9a.js",
        "uiduration.js": "uiduration.020e58.js",
        "uierror.js": "uierror.5e7e12.js",
        "uiipadlimit.js": "uiipadlimit.12e3f8.js",
        "uilanguage.js": "uilanguage.6de8fa.js",
        "uiloading.js": "uiloading.06c449.js",
        "uiloadingwithad.js": "uiloadingwithad.212225.js",
        "uilogo.js": "uilogo.518996.js",
        "uiloopplay.js": "uiloopplay.2caf22.js",
        "uinormalpoint.js": "uinormalpoint.86e464.js",
        "uiomsubscribe.js": "uiomsubscribe.df16ea.js",
        "uionlywatch.js": "uionlywatch.fc2cde.js",
        "uiopenclientbubble.js": "uiopenclientbubble.0b125e.js",
        "uioverlayplay.js": "uioverlayplay.499a9b.js",
        "uipip.js": "uipip.0819cc.js",
        "uiplay.js": "uiplay.495d38.js",
        "uiplaynext.js": "uiplaynext.117d64.js",
        "uiposter.js": "uiposter.498eb2.js",
        "uipreview.js": "uipreview.173693.js",
        "uipreviewad.js": "uipreviewad.1815d2.js",
        "uipreviewlist.js": "uipreviewlist.eac724.js",
        "uiprogress.js": "uiprogress.96983d.js",
        "uirightclickmenu.js": "uirightclickmenu.4ac2fd.js",
        "uiscreenpercent.js": "uiscreenpercent.0dc5f4.js",
        "uisettings.js": "uisettings.51827e.js",
        "uisettingsII.js": "uisettingsII.429108.js",
        "uishadow.js": "uishadow.e12265.js",
        "uishowtime.js": "uishowtime.6c6452.js",
        "uispeed.js": "uispeed.07cff2.js",
        "uisubtitle.js": "uisubtitle.ad037d.js",
        "uisubtitlebtn.js": "uisubtitlebtn.52e7d9.js",
        "uitips.js": "uitips.cbdeaf.js",
        "uititle.js": "uititle.b8824b.js",
        "uitogglesidebar.js": "uitogglesidebar.c273ed.js",
        "uitrbtngroup.js": "uitrbtngroup.bce250.js",
        "uiunofficialendtip.js": "uiunofficialendtip.23ffe3.js",
        "uivolume.js": "uivolume.41ee4c.js",
        "uiwatermark.js": "uiwatermark.47a7df.js",
        "uiwatermarkaction.js": "uiwatermarkaction.b41d39.js",
        "uiwindowfullscreen.js": "uiwindowfullscreen.e86410.js",
        "v4h5report.js": "v4h5report.37ef4c.js",
        "v4hdplayer.js": "v4hdplayer.cd4ca5.js",
        "v4hdplayercontrol.js": "v4hdplayercontrol.80f034.js",
        "v4hdplayerreport.js": "v4hdplayerreport.039f0d.js",
        "v4uicontrolplay.js": "v4uicontrolplay.9d52e0.js",
        "v4uidefinition.js": "v4uidefinition.f87b6a.js",
        "v4uierror.js": "v4uierror.acc424.js",
        "v4uivolume.js": "v4uivolume.f74072.js"
    }
}]);
! function () {
    if (window.Txplayer && Txplayer.dataset) {
        var a = {
            filename: "txplayer.js",
            lastModify: "2022-10-26 10:46:14",
            ts: "1666752374714",
            ver: "3.3.889"
        };
        for (var e in a) Txplayer.dataset[e] = a[e]
    }
}();